(function () {
  'use strict';

  if (window.__BS_WHITE_CART_DRAWER__) return;
  window.__BS_WHITE_CART_DRAWER__ = true;
  window.__BS_CORE_PURCHASE_PATH_STAGING__ = true;

  var VERSION = 'israel-rtl-cart-recovery-2026-07-27.1';
  var OFFER_VERSION = 'israel-complete-set-v1';
  var DRAWER_VERSION = 'concept-b-white-rtl-state-safe-1';
  var PITCHER_GUIDANCE_ENABLED = true;
  var PRESET_STARTER_KIT_ENABLED = true;
  var CUSTOM_PAIR_STARTER_KIT_ENABLED = true;
  // Keep the obsolete page-level custom-pair experiment dormant. The approved
  // implementation lives only in the shared white cart drawer.
  var CUSTOM_PAIR_PRODUCT_PAGE_SELECTOR_ENABLED = false;
  var ROUTES = {
    bundle: '/products/vortex-evo-latte-art-set',
    evo: '/products/evo',
    vortex: '/products/vortex',
    ultra: '/products/ultra-sharp',
    force: '/products/the-force-tamper',
    selector: '/pages/choose-a-free-pitcher',
    cart: '/cart'
  };
  var OFFER_TOTAL = 39900;
  var PAIR_DISCOUNT_PATTERN = /Two for 399/i;
  var PRESET_PRODUCT_ID = 10271583076653;
  var PRESET_VARIANTS = [52180492747053, 52180492714285];
  // The obsolete hidden-set conversion path remains unavailable. Zero sentinel
  // values prevent any failed staging resource from being referenced.
  var HIDDEN_SET_PRODUCT_ID = 0;
  var HIDDEN_SET_VARIANT_ID = 0;
  var HIDDEN_SET_PRICE = OFFER_TOTAL;
  var HIDDEN_SET_SKU = 'CUSTOM-2PITCHER-KIT';
  var STARTER_KIT_TEXT = 'מגבת בריסטה + פאק סקרין 58.5 מ״מ + עט לאטה ארט';
  // Verified in Shopify and through the Israeli Storefront Ajax API on 2026-07-21:
  // active, unlisted, cartable, native 0 ILS, and backed by three Shopify Bundles components.
  var STARTER_KIT_PRODUCT_ID = 10319099199789;
  var STARTER_KIT_VARIANT_ID = 52249555206445;
  var STARTER_KIT_REGULAR_PRICE = 13500;
  var PRESET_KIT_SOURCE = 'preset-bundle';
  var CUSTOM_PAIR_KIT_SOURCE = 'custom-pair';
  var ELIGIBLE = [
    {
      productId: 8438816637229,
      variantId: 45458566283565,
      handle: 'evo',
      product: 'EVO 2.0',
      option: 'שחור',
      sku: 'EVO002',
      available: true,
      image: 'https://cdn.shopify.com/s/files/1/0780/2463/8765/files/Mirror_Black_product_photo_5_e69d750b-1871-4c1e-ac6a-6db2c1f2590c.png?v=1777458001'
    },
    {
      productId: 8438816637229,
      variantId: 45458566250797,
      handle: 'evo',
      product: 'EVO 2.0',
      option: 'מולטיקולור',
      sku: 'EVO005',
      available: true,
      image: 'https://cdn.shopify.com/s/files/1/0780/2463/8765/files/EVO_Multicolor_Product_Photo.png?v=1776079737'
    },
    {
      productId: 9371166114093,
      variantId: 51814273122605,
      handle: 'vortex',
      product: 'Vortex',
      option: 'עם ידית',
      sku: 'Vortex001',
      available: true,
      image: 'https://cdn.shopify.com/s/files/1/0780/2463/8765/files/New_Vortex_Hero_Photo.png?v=1776001707'
    },
    {
      productId: 9371166114093,
      variantId: 51814273155373,
      handle: 'vortex',
      product: 'Vortex',
      option: 'ללא ידית',
      sku: 'Vortex001-NH',
      available: true,
      image: 'https://cdn.shopify.com/s/files/1/0780/2463/8765/files/Vortex_No_Handle_Product_Photo.png?v=1776002098'
    },
    {
      productId: 8559108063533,
      variantId: 48784721903917,
      handle: 'ultra-sharp',
      product: 'Ultra Sharp',
      option: '600 מ״ל / מולטיקולור',
      sku: 'IK016',
      available: true,
      image: 'https://cdn.shopify.com/s/files/1/0780/2463/8765/files/US2_Multicolor.png?v=1777892505'
    }
  ];
  var ELIGIBLE_IDS = ELIGIBLE.map(function (item) { return item.variantId; });
  // The live Israeli "Two for 399" discount currently accepts EVO and Vortex.
  // Ultra Sharp remains mapped for accurate cart classification but is suppressed
  // from the pair-choice UI until Shopify returns a real allocation for it.
  var QUALIFYING_FIRST_IDS = [45458566283565, 45458566250797, 51814273122605, 51814273155373];
  var SECOND_OPTION_IDS = [45458566283565, 45458566250797, 51814273122605, 51814273155373];
  var SECOND_OPTIONS = ELIGIBLE.filter(function (item) { return SECOND_OPTION_IDS.indexOf(item.variantId) !== -1; });
  var availabilityCheckedAt = 0;
  var mutationPending = false;
  var managedAddPending = false;
  var managedKitReconcilePending = false;
  var starterKitReconcilePromise = null;
  var lastRemovedItem = null;
  var undoTimer = null;
  var lastRenderedState = 'EMPTY';
  var bundleWhatsappObserver = null;
  var bundleWhatsappMedia = null;
  var bundleWhatsappHero = null;
  var path = location.pathname.replace(/\/$/, '') || '/';
  var isPurchasePath = Object.keys(ROUTES).some(function (key) { return path === ROUTES[key]; });

  document.documentElement.classList.add('bs-white-cart-enabled');
  if (isPurchasePath) document.documentElement.classList.add('bs-stage-core-path');
  window.__bsStageEvents = window.__bsStageEvents || new Set();

  function marketCode() {
    return (window.Shopify && window.Shopify.country) || document.documentElement.getAttribute('data-country') || '';
  }

  function deviceCategory() {
    if (matchMedia('(max-width: 599px)').matches) return 'mobile';
    if (matchMedia('(max-width: 1024px)').matches) return 'tablet';
    return 'desktop';
  }

  function currentProductHandle() {
    var match = path.match(/^\/products\/([^/]+)/);
    return match ? match[1] : '';
  }

  function emit(name, detail, dedupeKey) {
    detail = detail || {};
    var key = name + ':' + (dedupeKey || JSON.stringify(detail));
    if (window.__bsStageEvents.has(key)) return;
    window.__bsStageEvents.add(key);
    var params = new URLSearchParams(location.search);
    var payload = Object.assign({
      event: name,
      landing_page: path,
      product_handle: currentProductHandle(),
      page_version: VERSION,
      drawer_version: DRAWER_VERSION,
      offer_version: OFFER_VERSION,
      device_category: deviceCategory(),
      market_country: marketCode(),
      traffic_source: document.referrer ? new URL(document.referrer).hostname : 'direct',
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      starter_kit_state: PRESET_STARTER_KIT_ENABLED ? (CUSTOM_PAIR_STARTER_KIT_ENABLED ? 'preset-and-custom-enabled' : 'preset-enabled') : (CUSTOM_PAIR_STARTER_KIT_ENABLED ? 'custom-pair-enabled' : 'disabled')
    }, detail);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('bs:analytics', { detail: payload }));
    var debug = document.getElementById('bs-stage-analytics-debug');
    if (!debug) {
      debug = document.createElement('script');
      debug.id = 'bs-stage-analytics-debug';
      debug.type = 'application/json';
      debug.textContent = '[]';
      document.documentElement.appendChild(debug);
    }
    var debugEvents = JSON.parse(debug.textContent || '[]');
    debugEvents.push(payload);
    debug.textContent = JSON.stringify(debugEvents.slice(-50));
  }

  function money(cents) {
    var amount = Number(cents || 0) / 100;
    var formatted = amount.toLocaleString('he-IL', {
      minimumFractionDigits: Number(cents || 0) % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
    return formatted + ' ₪';
  }

  function eligibleById(variantId) {
    return ELIGIBLE.find(function (item) { return item.variantId === Number(variantId); }) || null;
  }

  function pitcherName(item) {
    return item ? item.product + ' — ' + item.option : '';
  }

  function pairPitcherAction(item) {
    if (!item) return 'הוספת כד לזוג';
    if (item.product === 'EVO 2.0') return 'הוספת EVO 2.0 לזוג';
    if (item.product === 'Vortex') return 'הוספת Vortex לזוג';
    return 'הוספת ' + item.product + ' לזוג';
  }

  function refreshAvailability() {
    if (Date.now() - availabilityCheckedAt < 60000) return Promise.resolve();
    var handles = Array.from(new Set(ELIGIBLE.map(function (item) { return item.handle; })));
    return Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('Availability could not be verified.'); return response.json(); })
        .then(function (product) {
          (product.variants || []).forEach(function (variant) {
            var item = eligibleById(variant.id);
            if (item) {
              item.available = Boolean(variant.available);
              item.option = variant.title && variant.title !== 'Default Title' ? variant.title : item.option;
              item.image = variant.featured_image && (variant.featured_image.src || variant.featured_image.url) ||
                product.featured_image || item.image;
            }
          });
        });
    })).then(function () { availabilityCheckedAt = Date.now(); });
  }

  function injectStyles() {
    if (document.getElementById('bs-stage-core-style')) return;
    var style = document.createElement('style');
    style.id = 'bs-stage-core-style';
    style.textContent = [
      '.bs-stage-core-path [id*="wheelio" i],.bs-stage-core-path [class*="wheelio" i],.bs-stage-core-path iframe[src*="wheelio" i],.bs-stage-core-path [id*="rollie" i],.bs-stage-core-path [class*="rollie" i],body.bs-stage-commerce-active [id*="wheelio" i],body.bs-stage-commerce-active [class*="wheelio" i],body.bs-stage-commerce-active iframe[src*="wheelio" i]{display:none!important;visibility:hidden!important;pointer-events:none!important}',
      '.bs-white-cart-enabled .cart-container .cart_content{display:none!important;visibility:hidden!important;pointer-events:none!important}',
      'body.bs-stage-commerce-active a[href*="wa.me" i],body.bs-stage-commerce-active a[href*="whatsapp" i],body.bs-stage-commerce-active [class*="whatsapp" i],body.bs-stage-commerce-active [id*="whatsapp" i],body.bs-stage-commerce-active iframe[src*="whatsapp" i]{display:none!important;visibility:hidden!important;pointer-events:none!important}',
      'body.bs-stage-commerce-active [id*="accessibility" i],body.bs-stage-commerce-active [class*="accessibility" i],body.bs-stage-commerce-active [id*="userway" i],body.bs-stage-commerce-active [class*="userway" i],body.bs-stage-commerce-active iframe[src*="userway" i],body.bs-stage-commerce-active iframe[src*="accessibility" i]{visibility:hidden!important;pointer-events:none!important}',
      '@media (max-width:420px){body.bs-stage-bundle-wa-suppressed a[href*="wa.me" i],body.bs-stage-bundle-wa-suppressed a[href*="whatsapp" i],body.bs-stage-bundle-wa-suppressed [class*="whatsapp" i],body.bs-stage-bundle-wa-suppressed [id*="whatsapp" i],body.bs-stage-bundle-wa-suppressed iframe[src*="whatsapp" i]{display:none!important;visibility:hidden!important;pointer-events:none!important}}',
      '#bs-cart-drawer-root{z-index:2147483000}',
      '#bs-cart-drawer-root [hidden]{display:none!important}',
      '[data-bs-context]:empty{display:none}',
      '.bs-cart-context{margin:18px 0 0}',
      '.bs-cart-eyebrow{margin:0 0 7px;color:#9b593a;font-size:11px;font-weight:800;letter-spacing:.12em;text-transform:uppercase}',
      '.bs-cart-state-title{margin:0 0 7px;color:#151515;font-size:18px;line-height:1.25;font-weight:760}',
      '.bs-cart-state-copy{margin:0;color:#686761;font-size:13px;line-height:1.5}',
      '.bs-cart-notice,.bs-cart-error{margin:14px 0;padding:13px 14px;border:1px solid #dedbd3;border-radius:8px;background:#fff;color:#373631;font-size:13px;line-height:1.45}',
      '.bs-cart-error{border-color:#d9aaa0;background:#fff5f2;color:#762d21}',
      '.bs-cart-retry,.bs-cart-secondary,.bs-cart-pair-action{width:100%;min-height:46px;margin-top:12px;border-radius:6px;font-size:13px;font-weight:760;cursor:pointer}',
      '.bs-cart-retry,.bs-cart-pair-action{border:0;background:#151515;color:#fff}',
      '.bs-cart-secondary{border:1px solid #bbb8b0;background:#fff;color:#151515}',
      '.bs-cart-retry:disabled,.bs-cart-pair-action:disabled,.bs-cart-secondary:disabled{opacity:.55;cursor:wait}',
      '.bs-line-prices{display:flex;align-items:baseline;gap:7px;flex-wrap:wrap}',
      '.bs-cart-price-wrap{margin:0}',
      '.bs-line-compare{color:#8d8a83;text-decoration:line-through;font-size:12px}',
      '.bs-line-discount{display:block;margin-top:3px;color:#2f6b46;font-size:11px;font-weight:760}',
      '.bs-each-price{margin:8px 0 0;color:#686761;font-size:12px}',
      '.bs-included-heading{display:flex;justify-content:space-between;gap:12px;align-items:end;margin:22px 0 10px}',
      '.bs-included-heading h3{margin:0;color:#151515;font-size:12px;font-weight:800;letter-spacing:.1em;text-transform:uppercase}',
      '.bs-included-heading span{color:#686761;font-size:11px;text-align:left}',
      '.bs-cart-options{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin:14px 0}',
      '.bs-cart-option{display:grid;grid-template-columns:54px 1fr;gap:9px;align-items:center;padding:9px;border:1px solid #dedbd3;border-radius:8px;background:#fff;color:#151515;text-align:right;cursor:pointer}',
      '.bs-cart-option[aria-pressed="true"]{border-color:#2f6b46;box-shadow:0 0 0 1px #2f6b46}',
      '.bs-cart-option:disabled{opacity:.45;cursor:not-allowed}',
      '.bs-cart-option img{width:54px;height:54px;border-radius:6px;object-fit:cover;background:#eeece6}',
      '.bs-cart-option strong,.bs-cart-option small{display:block}.bs-cart-option small{margin-top:3px;color:#686761;font-size:11px;line-height:1.25}',
      '.bs-cart-discount-summary{display:flex;justify-content:space-between;gap:15px;margin-top:12px;padding:12px 0;border-top:1px solid #dedbd3;color:#2f6b46;font-size:13px;font-weight:760}',
      '.bs-cart-loading{padding:36px 0;text-align:center;color:#686761;font-size:14px}',
      '.bs-cart-page-contract{max-width:760px;margin:18px auto;padding:14px 16px;border:1px solid #dedbd3;border-radius:8px;background:#f8f6f1;color:#151515}',
      '.bs-cart-page-contract p{margin:4px 0;color:#686761;font-size:13px;line-height:1.45}',
      '.bs-cart-page-contract strong{color:#151515}',
      '.bs-money-back{color:#b06a45!important}',
      'body.bs-stage-selector-active main>*:not(#bs-stage-selector-copy){display:none!important}body.bs-stage-selector-active #bs-stage-selector-copy{max-width:900px;margin:40px auto;padding:24px}',
      '@media(min-width:600px) and (max-width:1024px){.bs-stage-core-path #gC3o87pZC6,.bs-stage-core-path body.product-gp-template-618278482840912593 #gCUdBDRw_S{grid-template-columns:minmax(0,1fr)!important;row-gap:24px!important}.bs-stage-core-path #gC3o87pZC6>*,.bs-stage-core-path body.product-gp-template-618278482840912593 #gCUdBDRw_S>*{grid-column:1/-1!important;width:100%!important;max-width:100%!important}.bs-stage-core-path #gC3o87pZC6>.gd2s-PwPjJ,.bs-stage-core-path body.product-gp-template-618278482840912593 #gCUdBDRw_S>.gPuDqXleM2,.bs-stage-core-path body.product-gp-template-618278482840912593 #gCUdBDRw_S>.gjalT1VoGG{max-width:680px!important;margin-left:auto!important;margin-right:auto!important}}',
      '@media(min-width:761px) and (max-width:900px){.bs-stage-core-path .bs-bundle-page .hero{grid-template-columns:minmax(0,1fr)!important;align-items:start!important;gap:28px!important;max-height:none!important;padding-inline:44px!important}.bs-stage-core-path .bs-bundle-page .hero-copy,.bs-stage-core-path .bs-bundle-page .hero-gallery{width:100%!important;max-width:680px!important;margin-left:auto!important;margin-right:auto!important}}',
      '@media(max-width:600px){.bs-cart-options{grid-template-columns:1fr}.bs-cart-option{grid-template-columns:58px 1fr}.bs-cart-option img{width:58px;height:58px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function initBundleMobileWhatsapp() {
    if (path !== ROUTES.bundle) return;

    if (!bundleWhatsappMedia) {
      bundleWhatsappMedia = matchMedia('(max-width: 420px)');
      var syncForViewport = function () {
        var heroIsAheadOrVisible = Boolean(bundleWhatsappHero && bundleWhatsappHero.getBoundingClientRect().bottom > 0);
        document.body.classList.toggle('bs-stage-bundle-wa-suppressed', bundleWhatsappMedia.matches && heroIsAheadOrVisible);
      };
      if (bundleWhatsappMedia.addEventListener) bundleWhatsappMedia.addEventListener('change', syncForViewport);
      else if (bundleWhatsappMedia.addListener) bundleWhatsappMedia.addListener(syncForViewport);
    }

    var hero = document.querySelector('.bs-bundle-page .hero,[data-gem-page] main section:first-of-type,.shopify-section main section:first-of-type,main .banner:first-of-type,main section:first-of-type');
    if (!hero) return;
    if (hero === bundleWhatsappHero) return;

    if (bundleWhatsappObserver && bundleWhatsappHero) bundleWhatsappObserver.unobserve(bundleWhatsappHero);
    bundleWhatsappHero = hero;

    if (!('IntersectionObserver' in window)) {
      document.body.classList.toggle('bs-stage-bundle-wa-suppressed', bundleWhatsappMedia.matches);
      return;
    }

    bundleWhatsappObserver = bundleWhatsappObserver || new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target !== bundleWhatsappHero) return;
        var heroIsAheadOrVisible = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        document.body.classList.toggle('bs-stage-bundle-wa-suppressed', bundleWhatsappMedia.matches && heroIsAheadOrVisible);
      });
    }, { threshold: 0 });
    bundleWhatsappObserver.observe(bundleWhatsappHero);
    document.body.classList.toggle('bs-stage-bundle-wa-suppressed', bundleWhatsappMedia.matches && hero.getBoundingClientRect().bottom > 0);
  }

  function suppressWheelio(root) {
    root = root || document;
    var nodes = root.querySelectorAll ? root.querySelectorAll('[id*="wheelio" i],[class*="wheelio" i],iframe[src*="wheelio" i],[id*="rollie" i],[class*="rollie" i]') : [];
    nodes.forEach(function (node) {
      node.setAttribute('aria-hidden', 'true');
      node.setAttribute('hidden', '');
      node.setAttribute('inert', '');
      if ('inert' in node) node.inert = true;
      node.querySelectorAll && node.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (control) {
        control.setAttribute('tabindex', '-1');
      });
    });
  }

  function suppressLegacyDrawer(root) {
    root = root || document;
    var selector = '.cart-container .cart_content,#CartDrawer,[id="cart-drawer"]:not(#bs-cart-drawer-root),cart-drawer:not(#bs-cart-drawer-root)';
    var nodes = [];
    if (root.matches && root.matches(selector)) nodes.push(root);
    if (root.querySelectorAll) nodes = nodes.concat(Array.from(root.querySelectorAll(selector)));
    nodes.forEach(function (node) {
      if (node.id === 'bs-cart-drawer-root' || node.closest && node.closest('#bs-cart-drawer-root')) return;
      node.setAttribute('aria-hidden', 'true');
      node.setAttribute('hidden', '');
      if ('inert' in node) node.inert = true;
      node.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (control) {
        control.setAttribute('tabindex', '-1');
      });
    });
  }

  function bindLegacyCartClassGuards() {
    document.querySelectorAll('.cart-container').forEach(function (container) {
      if (container.getAttribute('data-bs-class-guard') === 'true') return;
      container.setAttribute('data-bs-class-guard', 'true');
      new MutationObserver(function () {
        if (container.classList.contains('active_link')) {
          container.classList.remove('active_link');
          if (!document.querySelector('#bs-cart-drawer-root[aria-hidden="false"]')) document.body.classList.remove('blocked-scroll');
        }
      }).observe(container, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function regionalHtml() {
    return '<div class="bs-stage-region">' +
      '<div>399 ₪ מחיר סופי, כולל מע״מ ומשלוח.</div>' +
      '<div>משלוח חינם. זמן האספקה הממוצע הוא כ־3 ימים, ועד 5 ימי עסקים.</div>' +
      '</div>';
  }

  function guaranteeHtml() {
    return '<details class="bs-stage-guarantee"><summary>לאטה ארט טוב יותר בתוך 21 יום, <span class="bs-money-back">או שתקבלו את כספכם בחזרה.</span>' +
      '<span class="bs-stage-condition">התנסות של 21 ימים לפחות · בקשת החזר עד היום ה־45 · משלוח החזרה חינם</span></summary>' +
      '<p>נסו את הסט המלא במשך 21 ימים לפחות. אם לא חל שיפור, אפשר לבקש החזר עד 45 ימים ממועד המסירה.</p>' +
      '<p>אנחנו נדאג למשלוח החזרה מלווה במעקב וללא עלות. יש להחזיר את הסט המלא, כולל ערכת ההתחלה.</p>' +
      '<p>שימוש סביר לצורך ההתנסות מותר. אין באחריות זו כדי לגרוע מזכויותיכם על פי דין.</p>' +
      '<p><a href="/pages/return-policy">למדיניות ההחזרות המלאה</a></p></details>';
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('לא הצלחנו לטעון את הסל.');
      return response.json();
    });
  }

  function addCartItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'לא הצלחנו לעדכן את הסל.'); });
      return response.json();
    });
  }

  function updateCartLines(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'לא הצלחנו לעדכן את הסל.'); });
      return response.json();
    });
  }

  function starterKitProperties(source) {
    return {
      '_bs_kit_source': source,
      '_bs_offer_version': OFFER_VERSION
    };
  }

  function starterKitSource(line) {
    var properties = line && line.properties || {};
    return properties._bs_kit_source || '';
  }

  function kitLineIsNativeZero(line) {
    var discounts = line && (line.line_level_discount_allocations || []);
    return Boolean(line) && Number(line.variant_id) === STARTER_KIT_VARIANT_ID &&
      Number(line.price || 0) === 0 && Number(line.original_price || 0) === 0 &&
      Number(line.final_price || 0) === 0 && Number(line.line_price || 0) === 0 &&
      Number(line.final_line_price || 0) === 0 && discounts.length === 0;
  }

  function hiddenSetProperties(firstItem, secondItem, sourcePage) {
    return {
      'First Pitcher': pitcherName(firstItem),
      'Second Pitcher': pitcherName(secondItem),
      'Starter Kit': STARTER_KIT_TEXT,
      '_first_variant_id': String(firstItem.variantId),
      '_second_variant_id': String(secondItem.variantId),
      '_first_sku': firstItem.sku,
      '_second_sku': secondItem.sku,
      '_offer_version': OFFER_VERSION,
      '_source_page': sourcePage || path
    };
  }

  function hiddenLineIsValid(line) {
    var properties = line && line.properties || {};
    return Boolean(line) && Number(line.variant_id) === HIDDEN_SET_VARIANT_ID && Number(line.quantity) === 1 &&
      Number(line.final_line_price) === HIDDEN_SET_PRICE && properties['First Pitcher'] && properties['Second Pitcher'] &&
      properties['Starter Kit'] === STARTER_KIT_TEXT && properties._offer_version === OFFER_VERSION;
  }

  function cartFacts(cart) {
    var presetLines = [];
    var eligibleLines = [];
    var eligibleCartLines = [];
    var hiddenLines = [];
    var starterKitLines = [];
    var starterKitCartLines = [];
    var presetKitCartLines = [];
    var customKitCartLines = [];
    var unownedKitCartLines = [];
    var otherLines = [];
    var unrelatedLines = [];
    var presetQuantity = 0;
    var presetTotal = 0;
    var starterKitCount = 0;
    var presetKitQuantity = 0;
    var customKitQuantity = 0;
    var nonKitTotal = 0;
    var pairDiscountAmount = 0;
    var pairDiscountTitles = [];
    cart.items.forEach(function (line) {
      if (isPresetLine(line)) {
        presetLines.push(line);
        presetQuantity += Number(line.quantity || 0);
        presetTotal += Number(line.final_line_price || 0);
        nonKitTotal += Number(line.final_line_price || 0);
        return;
      }
      if (Number(line.product_id) === HIDDEN_SET_PRODUCT_ID || Number(line.variant_id) === HIDDEN_SET_VARIANT_ID) {
        for (var h = 0; h < Number(line.quantity || 1); h += 1) hiddenLines.push(line);
        nonKitTotal += Number(line.final_line_price || 0);
        return;
      }
      if (Number(line.product_id) === STARTER_KIT_PRODUCT_ID || Number(line.variant_id) === STARTER_KIT_VARIANT_ID) {
        var kitQuantity = Number(line.quantity || 0);
        var source = starterKitSource(line);
        starterKitCartLines.push(line);
        starterKitCount += kitQuantity;
        for (var k = 0; k < kitQuantity; k += 1) starterKitLines.push(line);
        if (source === PRESET_KIT_SOURCE) {
          presetKitCartLines.push(line);
          presetKitQuantity += kitQuantity;
        } else if (source === CUSTOM_PAIR_KIT_SOURCE) {
          customKitCartLines.push(line);
          customKitQuantity += kitQuantity;
        } else unownedKitCartLines.push(line);
        // When the feature is off, the Kit remains an ordinary purchasable product.
        if (!CUSTOM_PAIR_STARTER_KIT_ENABLED) {
          otherLines.push(line);
          unrelatedLines.push(line);
        }
        return;
      }
      nonKitTotal += Number(line.final_line_price || 0);
      otherLines.push(line);
      if (ELIGIBLE_IDS.indexOf(Number(line.variant_id)) !== -1) {
        eligibleCartLines.push(line);
        for (var i = 0; i < Number(line.quantity || 1); i += 1) eligibleLines.push(line);
        (line.line_level_discount_allocations || []).forEach(function (allocation) {
          var title = allocation.discount_application && allocation.discount_application.title || '';
          if (PAIR_DISCOUNT_PATTERN.test(title)) {
            pairDiscountAmount += Number(allocation.amount || 0);
            if (pairDiscountTitles.indexOf(title) === -1) pairDiscountTitles.push(title);
          }
        });
      } else unrelatedLines.push(line);
    });
    var preset = presetLines.length > 0;
    var starterKitLine = starterKitCartLines[0] || null;
    var customKitLine = customKitCartLines[0] || null;
    var starterKitFree = starterKitCartLines.length === 1 && customKitCartLines.length === 1 &&
      customKitQuantity === 1 && kitLineIsNativeZero(customKitLine);
    var presetAtOfferTotal = preset && presetQuantity > 0 && presetTotal === presetQuantity * OFFER_TOTAL &&
      Number(cart.total_price) === nonKitTotal;
    var presetKitVerified = presetAtOfferTotal && starterKitCartLines.length === 1 &&
      presetKitCartLines.length === 1 && presetKitQuantity === presetQuantity &&
      kitLineIsNativeZero(presetKitCartLines[0]);
    var exactPair = !preset && eligibleLines.length === 2 && unrelatedLines.length === 0 &&
      hiddenLines.length === 0 && starterKitCount === 0;
    var pairAtOfferTotal = exactPair && pairDiscountAmount > 0 && pairDiscountTitles.length > 0 && Number(cart.total_price) === OFFER_TOTAL;
    var completePair = !preset && eligibleLines.length === 2 && unrelatedLines.length === 0 &&
      hiddenLines.length === 0 && starterKitCartLines.length === 1 && customKitQuantity === 1;
    var starterKitVerified = completePair && starterKitFree && pairDiscountAmount > 0 &&
      pairDiscountTitles.length > 0 && Number(cart.total_price) === OFFER_TOTAL;
    return {
      preset: preset,
      presetLines: presetLines,
      presetQuantity: presetQuantity,
      presetTotal: presetTotal,
      presetAtOfferTotal: presetAtOfferTotal,
      presetKitVerified: presetKitVerified,
      onlyPreset: preset && otherLines.length === 0 && hiddenLines.length === 0 && presetKitVerified,
      mixedPreset: preset && (otherLines.length > 0 || hiddenLines.length > 0),
      eligibleLines: eligibleLines,
      eligibleCartLines: eligibleCartLines,
      eligibleCount: eligibleLines.length,
      otherLines: otherLines,
      unrelatedLines: unrelatedLines,
      exactPair: exactPair,
      pairAtOfferTotal: pairAtOfferTotal,
      pairDiscountAmount: pairDiscountAmount,
      pairDiscountTitles: pairDiscountTitles,
      pairDiscountApplied: pairDiscountAmount > 0 && pairDiscountTitles.length > 0,
      hiddenLines: hiddenLines,
      hiddenCount: hiddenLines.length,
      hiddenLine: hiddenLines[0] || null,
      hiddenValid: hiddenLines.length === 1 && hiddenLineIsValid(hiddenLines[0]),
      hiddenConflict: hiddenLines.length > 0 && (hiddenLines.length !== 1 || eligibleLines.length > 0 || !hiddenLineIsValid(hiddenLines[0])),
      mixedOffer: preset && hiddenLines.length > 0,
      starterKitLines: starterKitLines,
      starterKitCartLines: starterKitCartLines,
      starterKitCount: starterKitCount,
      starterKitLine: starterKitLine,
      presetKitCartLines: presetKitCartLines,
      presetKitQuantity: presetKitQuantity,
      customKitCartLines: customKitCartLines,
      customKitQuantity: customKitQuantity,
      unownedKitCartLines: unownedKitCartLines,
      nonKitTotal: nonKitTotal,
      starterKitFree: starterKitFree,
      starterKitVerified: starterKitVerified
    };
  }

  function isPresetLine(line) {
    return Number(line.product_id) === PRESET_PRODUCT_ID || PRESET_VARIANTS.indexOf(Number(line.variant_id)) !== -1;
  }

  function isStarterKitLine(line) {
    return Number(line.product_id) === STARTER_KIT_PRODUCT_ID || Number(line.variant_id) === STARTER_KIT_VARIANT_ID;
  }

  function itemImage(line) {
    return line.image || line.featured_image && (line.featured_image.url || line.featured_image.src) || '';
  }

  function lineDiscountLabel(line) {
    var titles = (line.line_level_discount_allocations || []).map(function (allocation) {
      return allocation.discount_application && allocation.discount_application.title || '';
    }).filter(Boolean);
    return titles.length ? titles.join(' · ') : '';
  }

  function lineHtml(line, currency) {
    var preset = isPresetLine(line);
    var title = preset ? 'EVO 2.0 + Vortex' : (line.product_title || line.title || 'פריט');
    var rawVariant = line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : '';
    var variant = preset ? 'גימור EVO: ' + (rawVariant || 'הגימור שנבחר') : rawVariant;
    var image = itemImage(line);
    var key = String(line.key || line.variant_id || '');
    var quantity = Math.max(1, Number(line.quantity || 1));
    var original = Number(line.original_line_price == null ? line.final_line_price : line.original_line_price);
    var finalPrice = Number(line.final_line_price || 0);
    var discount = lineDiscountLabel(line);
    var priceMarkup = '<div class="bs-line-prices">' +
      (original > finalPrice ? '<span class="bs-line-compare">' + money(original, currency) + '</span>' : '') +
      '<strong class="bs-cart-price">' + money(finalPrice, currency) + '</strong></div>' +
      (discount ? '<span class="bs-line-discount">הנחת ' + escapeHtml(discount) + ' הוחלה</span>' : '');
    return '<article class="bs-cart-item" data-bs-key="' + escapeHtml(key) + '">' +
      (image ? '<img class="bs-cart-image" src="' + escapeHtml(image) + '" alt="">' : '<div class="bs-cart-image" aria-hidden="true"></div>') +
      '<div class="bs-cart-item-info"><h2 class="bs-cart-item-title">' + escapeHtml(title) + '</h2>' +
      (variant ? '<p class="bs-cart-variant">' + escapeHtml(variant) + '</p>' : '') +
      '<div class="bs-cart-price-wrap">' + priceMarkup + '</div>' +
      '<div class="bs-cart-item-actions"><div class="bs-quantity" role="group" aria-label="כמות עבור ' + escapeHtml(title) + '">' +
      '<button type="button" data-bs-quantity="' + (quantity - 1) + '" data-bs-key="' + escapeHtml(key) + '" aria-label="הפחתת כמות"' + (quantity <= 1 ? ' disabled' : '') + '>−</button>' +
      '<output aria-live="polite" aria-label="כמות ' + quantity + '">' + quantity + '</output>' +
      '<button type="button" data-bs-quantity="' + (quantity + 1) + '" data-bs-key="' + escapeHtml(key) + '" aria-label="הגדלת כמות">+</button></div>' +
      '<button class="bs-remove" type="button" data-bs-remove data-bs-key="' + escapeHtml(key) + '">הסרה</button></div></div></article>';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character];
    });
  }

  function ensureDrawer() {
    var root = document.getElementById('bs-cart-drawer-root');
    if (!root) return null;
    if (root.getAttribute('data-bs-engine-bound') === 'true') return root;
    root.setAttribute('data-bs-engine-bound', 'true');
    root.addEventListener('click', function (event) {
      var close = event.target.closest('[data-bs-close]');
      if (close) { closeDrawer(); return; }
      var panelButton = event.target.closest('[data-bs-panel-button]');
      if (panelButton) {
        setPanel(panelButton.getAttribute('data-bs-panel-button'));
        return;
      }
      var quantityButton = event.target.closest('[data-bs-quantity]');
      if (quantityButton) {
        changeCartLine(quantityButton.getAttribute('data-bs-key'), Number(quantityButton.getAttribute('data-bs-quantity')));
        return;
      }
      var removeButton = event.target.closest('[data-bs-remove]');
      if (removeButton) {
        removeCartLine(removeButton.getAttribute('data-bs-key'));
        return;
      }
      if (event.target.closest('[data-bs-undo]')) { undoRemove(); return; }
      var checkoutButton = event.target.closest('[data-bs-checkout]');
      if (checkoutButton) {
        if (checkoutButton.getAttribute('data-bs-action') === 'add-second') addSelectedSecondPitcher();
        else if (checkoutButton.getAttribute('data-bs-action') === 'add-starter-kit') addStarterKit();
        else checkoutCart();
        return;
      }
      if (event.target.closest('[data-bs-retry]')) {
        var retryNodes = drawerNodes();
        if (retryNodes) retryNodes.heading.textContent = 'הסל רוענן';
        renderDrawer();
        return;
      }
      var option = event.target.closest('[data-bs-second]');
      if (option) { selectSecondPitcher(option); return; }
      if (event.target.closest('[data-bs-add-second]')) addSelectedSecondPitcher();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
      if (event.key !== 'Tab') return;
      var focusable = Array.from(root.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (element) { return element.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    return root;
  }

  var lastTrigger = null;
  var latestCart = null;
  var selectedSecondVariant = 0;

  function drawerNodes() {
    var root = ensureDrawer();
    return root ? {
      root: root,
      drawer: root.querySelector('.bs-cart-drawer'),
      body: root.querySelector('[data-bs-body]'),
      items: root.querySelector('[data-bs-items]'),
      context: root.querySelector('[data-bs-context]'),
      rating: root.querySelector('[data-bs-rating]'),
      assurance: root.querySelector('[data-bs-assurance]'),
      summary: root.querySelector('[data-bs-summary]'),
      total: root.querySelector('[data-bs-total]'),
      totalLabel: root.querySelector('[data-bs-total-label]'),
      checkout: root.querySelector('[data-bs-checkout]'),
      heading: root.querySelector('[data-bs-heading]'),
      chargeShort: root.querySelector('[data-bs-charge-short]'),
      chargeDetail: root.querySelector('[data-bs-charge-detail]'),
      footerGuarantee: root.querySelector('[data-bs-footer-guarantee]'),
      trustDot: root.querySelector('.bs-trust-dot'),
      toast: root.querySelector('[data-bs-toast]')
    } : null;
  }

  function setPanel(name) {
    var nodes = drawerNodes();
    if (!nodes) return;
    nodes.root.querySelectorAll('[data-bs-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-bs-panel') !== name;
    });
    nodes.root.querySelectorAll('[data-bs-panel-button]').forEach(function (button) {
      var open = button.getAttribute('data-bs-panel-button') === name;
      button.setAttribute('aria-expanded', String(open));
      var chevron = button.querySelector('.bs-chevron');
      if (chevron) chevron.classList.toggle('is-open', open);
    });
  }

  function openDrawer(trigger, message) {
    lastTrigger = trigger || document.activeElement;
    var nodes = drawerNodes();
    if (!nodes) return Promise.reject(new Error('חלונית הסל אינה זמינה כרגע.'));
    var alreadyOpen = nodes.root.getAttribute('aria-hidden') === 'false' && !nodes.root.hidden;
    nodes.root.hidden = false;
    nodes.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bs-stage-commerce-active');
    document.body.classList.add('bs-cart-open');
    suppressLegacyDrawer(document);
    document.body.style.overflow = 'hidden';
    sessionStorage.setItem('bs_white_drawer_open', '1');
    var postAdd = sessionStorage.getItem('bs_stage_post_add') === '1';
    if (postAdd) sessionStorage.removeItem('bs_stage_post_add');
    nodes.heading.textContent = message || (postAdd ? 'נוסף לסל' : (alreadyOpen ? 'הסל עודכן' : 'הסל שלכם'));
    renderLoading(nodes);
    if (!alreadyOpen) {
      nodes.drawer.focus({ preventScroll: true });
      emit('bs_drawer_open', {}, 'open:' + Date.now());
    }
    return renderDrawer();
  }

  function closeDrawer() {
    var nodes = drawerNodes();
    if (!nodes) return;
    nodes.root.hidden = true;
    nodes.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bs-stage-commerce-active');
    document.body.classList.remove('bs-cart-open');
    document.body.classList.remove('blocked-scroll');
    document.querySelectorAll('.cart-container.active_link').forEach(function (container) { container.classList.remove('active_link'); });
    document.body.style.overflow = '';
    sessionStorage.removeItem('bs_white_drawer_open');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
    if (path === ROUTES.cart) location.reload();
  }

  function renderLoading(nodes) {
    nodes.items.innerHTML = '';
    nodes.context.innerHTML = '<div class="bs-cart-loading" role="status">טוענים את הסל…</div>';
    nodes.rating.hidden = true;
    nodes.assurance.hidden = true;
    nodes.summary.hidden = true;
  }

  function updateCartCount(cart) {
    var selectors = ['[data-cart-count]', '.cart_count', '.cart-count', '.header-cart__count', '[data-cart-count-bubble]'];
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        node.textContent = String(cart.item_count || 0);
        node.hidden = false;
      });
    });
    document.dispatchEvent(new CustomEvent('bs:cart-updated', { detail: { cart: cart } }));
  }

  function marketCopy(state, facts) {
    if (state === 'P0' && facts.mixedPreset) return {
      short: 'לסט: 399 ₪ כולל מע״מ ומשלוח · יתר הפריטים מחושבים בנפרד',
      detail: 'כל סט מלא עולה 399 ₪, כולל מע״מ ומשלוח. מחירם של יתר הפריטים בסל מוצג בסיכום ההזמנה.'
    };
    if (state === 'P0' && facts.presetQuantity > 1) return {
      short: 'כל סט מלא: 399 ₪ כולל מע״מ ומשלוח · סה״כ בסל: ' + money(facts.presetTotal),
      detail: facts.presetQuantity + ' סטים מלאים במחיר 399 ₪ לסט, כולל מע״מ ומשלוח. סה״כ בסל: ' + money(facts.presetTotal) + '.'
    };
    if (state === 'E1') return {
      short: 'מחיר הזוג לאחר הוספת כד נוסף: 399 ₪ · משלוח חינם בישראל ברכישת כד',
      detail: 'כד אחד עולה 269 ₪. לאחר הוספת כד נוסף, המחיר הכולל לשני הכדים יהיה 399 ₪, כולל מע״מ ומשלוח.'
    };
    if (state === 'P0' || state === 'E2' || state === 'E3') return {
      short: '399 ₪ מחיר סופי · משלוח חינם בישראל ברכישת כד',
      detail: '399 ₪ מחיר סופי, כולל מע״מ ומשלוח. אין חיובים נוספים.'
    };
    return {
      short: 'המחיר כולל מע״מ. עלויות המשלוח מוצגות לפני התשלום.',
      detail: 'המחיר כולל מע״מ. עלויות המשלוח, אם ישנן, מוצגות בסיכום ההזמנה לפני התשלום.'
    };
  }

  function prepareShell(state, cart, facts) {
    var nodes = drawerNodes();
    var guaranteeApplies = state === 'P0' || state === 'E1' || state === 'PAIR' || state === 'E2' || state === 'E3';
    var commerceContent = cart.item_count > 0;
    var copy = marketCopy(state, facts);
    lastRenderedState = state;
    nodes.root.setAttribute('data-bs-state', state);
    nodes.body.setAttribute('data-bs-state', state);
    nodes.rating.hidden = !(state === 'P0' || state === 'E1' || state === 'PAIR' || state === 'E2' || state === 'E3');
    nodes.assurance.hidden = !commerceContent;
    nodes.root.querySelectorAll('[data-bs-guarantee-section]').forEach(function (element) { element.hidden = !guaranteeApplies; });
    nodes.root.querySelectorAll('[data-bs-charges-section]').forEach(function (element) {
      if (element.hasAttribute('data-bs-panel')) return;
      element.hidden = !commerceContent;
    });
    nodes.root.querySelectorAll('[data-bs-payment]').forEach(function (element) { element.hidden = !commerceContent; });
    nodes.footerGuarantee.hidden = !guaranteeApplies;
    nodes.trustDot.hidden = !guaranteeApplies;
    nodes.summary.hidden = !commerceContent;
    nodes.total.textContent = money(cart.total_price, cart.currency);
    nodes.totalLabel.textContent = state === 'P0' && facts.onlyPreset && facts.presetQuantity === 1 ? 'סה״כ לסט' : 'סה״כ בסל';
    nodes.checkout.disabled = false;
    nodes.checkout.removeAttribute('data-bs-action');
    nodes.checkout.textContent = 'לתשלום — ' + money(cart.total_price, cart.currency);
    nodes.chargeShort.textContent = copy.short;
    nodes.chargeDetail.textContent = copy.detail;
    if (guaranteeApplies) setPanel('guarantee');
    else setPanel(null);
    return nodes;
  }

  function presetContentsHtml(facts) {
    var finishCounts = {};
    facts.presetLines.forEach(function (line) {
      var finish = line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : 'הגימור שנבחר';
      finishCounts[finish] = (finishCounts[finish] || 0) + Number(line.quantity || 0);
    });
    var finishes = Object.keys(finishCounts).map(function (finish) {
      return facts.presetQuantity > 1 ? finish + ' × ' + finishCounts[finish] : finish;
    }).join(' · ');
    var quantitySuffix = facts.presetQuantity > 1 ? ' × ' + facts.presetQuantity : '';
    return '<h3 class="bs-section-title">כל מה שכלול</h3>' +
      (facts.presetQuantity > 1 || facts.mixedPreset ? '<p class="bs-each-price">כל סט מלא: 399 ₪</p>' : '') +
      '<div class="bs-included-card" aria-label="תכולת סט הלאטה ארט המלא">' +
      '<div class="bs-included-row"><span class="bs-item-check" aria-hidden="true">✓</span><span class="bs-included-copy"><strong>כד EVO 2.0' + quantitySuffix + '</strong><small>' + escapeHtml(finishes) + '</small></span></div>' +
      '<div class="bs-included-row"><span class="bs-item-check" aria-hidden="true">✓</span><span class="bs-included-copy"><strong>כד Vortex' + quantitySuffix + '</strong><small>500 מ״ל לכל כד</small></span></div>' +
      '<div class="bs-included-row"><span class="bs-item-check" aria-hidden="true">✓</span><span class="bs-included-copy"><strong>ערכת התחלה ללאטה ארט' + quantitySuffix + '</strong><small>מגבת בריסטה, פאק סקרין 58.5 מ״מ ועט לאטה ארט</small></span><span class="bs-free-pill">כלולה</span></div></div>';
  }

  function stateForCart(cart) {
    var facts = cartFacts(cart);
    if (!cart.item_count) return 'EMPTY';
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && (facts.mixedOffer || facts.hiddenConflict)) return 'ERR';
    if (facts.preset) return facts.presetKitVerified ? 'P0' : 'ERR';
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.starterKitVerified) return 'E3';
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.pairAtOfferTotal) return 'E2';
    if (PITCHER_GUIDANCE_ENABLED && facts.eligibleCount === 1 && facts.unrelatedLines.length === 0 &&
      facts.starterKitCount === 0 && QUALIFYING_FIRST_IDS.indexOf(Number(facts.eligibleLines[0].variant_id)) !== -1) return 'E1';
    if (PITCHER_GUIDANCE_ENABLED && facts.eligibleCount === 2) return 'PAIR';
    return 'E0';
  }

  function renderDrawer() {
    var nodes = drawerNodes();
    if (!nodes) return Promise.reject(new Error('חלונית הסל אינה זמינה כרגע.'));
    return Promise.all([getCart(), refreshAvailability()]).then(function (results) {
      return reconcileStarterKitAuthority(results[0]);
    }).then(function (cart) {
      latestCart = cart;
      updateCartCount(cart);
      var facts = cartFacts(cart);
      var state = stateForCart(cart);
      if (state === 'EMPTY' || state === 'E0') return renderNormal(nodes.body, cart, facts);
      if (state === 'P0') return renderPreset(nodes.body, cart, facts);
      if (state === 'ERR') return renderOfferConflict(nodes.body, cart, facts);
      if (state === 'E2') return renderStarterKitReady(nodes.body, cart, facts);
      if (state === 'E3') return renderCompletePair(nodes.body, cart, facts);
      if (state === 'E1') return renderOne(nodes.body, cart, facts);
      if (state === 'PAIR') return renderPair(nodes.body, cart, facts);
      return renderNormal(nodes.body, cart, facts);
    }).catch(function (error) {
      emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'cart_fetch' }, 'fetch');
      return getCart().then(function (cart) {
        latestCart = cart;
        updateCartCount(cart);
        renderRecoverableError(error, cart);
        return cart;
      }).catch(function () { renderRecoverableError(error); });
    });
  }

  function renderRecoverableError(error, refreshedCart) {
    var cart = refreshedCart || latestCart || { items: [], item_count: 0, total_price: 0, currency: 'ILS' };
    var facts = cartFacts(cart);
    var nodes = prepareShell('ERR', cart, facts);
    nodes.heading.textContent = 'צריך לרענן את הסל';
    nodes.items.innerHTML = (cart.items || []).map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-error" role="alert"><strong>לא הצלחנו להשלים את עדכון הסל.</strong><br>' + escapeHtml(error.message || 'נסו שוב.') + '</div><button class="bs-cart-retry" type="button" data-bs-retry>רענון הסל</button>';
    nodes.rating.hidden = true;
    nodes.assurance.hidden = !cart.item_count;
  }

  function renderOfferConflict(body, cart, facts) {
    emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'duplicate_complete_sets' }, 'duplicate-sets:' + cart.token + ':' + cart.item_count);
    var nodes = prepareShell('ERR', cart, facts);
    nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-error"><strong>בחרו הצעה אחת לסט מלא.</strong><br>אי אפשר להשלים יחד סט מוכן וסט בהתאמה אישית.</div>';
  }

  function renderPreset(body, cart, facts) {
    var nodes = prepareShell('P0', cart, facts);
    // The real managed Kit line is verified in Shopify but represented inside the
    // approved compact inclusion card to avoid duplicating it visually.
    nodes.items.innerHTML = cart.items.filter(function (line) { return !isStarterKitLine(line); }).map(function (line) { return lineHtml(line, cart.currency); }).join('') + presetContentsHtml(facts);
    if (facts.mixedPreset) {
      nodes.context.innerHTML = '<div class="bs-cart-notice"><strong>מחיר הסט: 399 ₪ ליחידה.</strong><br>הסכום הכולל בסל כולל גם את יתר המוצרים המוצגים למעלה.</div>';
    } else if (facts.presetQuantity > 1) {
      nodes.context.innerHTML = '<div class="bs-cart-notice"><strong>' + facts.presetQuantity + ' סטים מלאים</strong><br>כל סט מלא: 399 ₪ · הסכום בפועל בסל: ' + money(cart.total_price, cart.currency) + '</div>';
    } else nodes.context.innerHTML = '';
    emit('bs_cart_state_view', { drawer_state: 'P0', preset_quantity: facts.presetQuantity, cart_total: cart.total_price }, 'state:P0:' + cart.token + ':' + cart.item_count + ':' + cart.total_price);
  }

  function renderNormal(body, cart, facts) {
    var state = cart.item_count ? 'E0' : 'EMPTY';
    var nodes = prepareShell(state, cart, facts);
    nodes.rating.hidden = true;
    if (cart.item_count) {
      nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
      nodes.context.innerHTML = '';
      emit('bs_cart_state_view', { drawer_state: 'E0', cart_total: cart.total_price }, 'state:E0:' + cart.token + ':' + cart.item_count + ':' + cart.total_price);
    } else {
      nodes.items.innerHTML = '';
      nodes.context.innerHTML = '<div class="bs-cart-empty"><div class="bs-empty-mark" aria-hidden="true">✓</div><h2>הסל שלכם ריק</h2><p>הוסיפו מוצר כשתהיו מוכנים.</p><button type="button" data-bs-close>המשך בקנייה</button></div>';
      nodes.assurance.hidden = true;
      nodes.summary.hidden = true;
    }
  }

  function renderOne(body, cart, facts) {
    var nodes = prepareShell('E1', cart, facts);
    selectedSecondVariant = 0;
    emit('bs_second_pitcher_prompt_view', { drawer_state: 'E1', first_pitcher_variant: Number(facts.eligibleLines[0].variant_id) }, 'E1:' + cart.token);
    nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-context"><p class="bs-cart-eyebrow">הטבה לזוג כדים</p>' +
      '<h3 class="bs-cart-state-title">השלימו זוג כדים ב־399 ₪</h3>' +
      '<p class="bs-cart-state-copy">כד אחד עולה 269 ₪<br>שני כדי EVO/Vortex ב־399 ₪<br>חיסכון של 139 ₪</p>' +
      '<div class="bs-cart-options">' + SECOND_OPTIONS.map(function (item) {
        return '<button class="bs-cart-option" type="button" data-bs-second="' + item.variantId + '" aria-pressed="false" ' + (item.available ? '' : 'disabled') + '>' +
          '<img src="' + escapeHtml(item.image) + '" alt=""><span><strong>' + escapeHtml(pairPitcherAction(item)) + '</strong><small>' + escapeHtml(item.option) + (item.available ? ' · במלאי' : ' · אזל מהמלאי') + '</small></span></button>';
      }).join('') + '</div></div>';
    nodes.checkout.setAttribute('data-bs-action', 'add-second');
    nodes.checkout.disabled = true;
    nodes.checkout.textContent = 'בחרו כד נוסף';
  }

  function selectSecondPitcher(button) {
    selectedSecondVariant = Number(button.getAttribute('data-bs-second'));
    var nodes = drawerNodes();
    nodes.context.querySelectorAll('[data-bs-second]').forEach(function (candidate) {
      candidate.setAttribute('aria-pressed', String(candidate === button));
    });
    var item = SECOND_OPTIONS.find(function (candidate) { return candidate.variantId === selectedSecondVariant; });
    var action = nodes.checkout;
    if (!item || !item.available) return;
    action.disabled = false;
    action.textContent = pairPitcherAction(item);
    emit('bs_second_pitcher_selected', { drawer_state: 'E1', second_pitcher_variant: selectedSecondVariant }, 'select:' + selectedSecondVariant);
  }

  function addSelectedSecondPitcher() {
    if (!selectedSecondVariant || mutationPending) return;
    var nodes = drawerNodes();
    var button = nodes.checkout;
    var item = eligibleById(selectedSecondVariant);
    mutationPending = true;
    button.disabled = true;
    button.textContent = 'מוסיפים את הכד…';
    refreshAvailability().then(function () {
      if (!item || !item.available) throw new Error('הכד הזה אינו זמין עוד. בחרו אפשרות אחרת.');
      return addCartItems([{ id: selectedSecondVariant, quantity: 1 }]);
    }).then(getCart).then(function (cart) {
      var facts = cartFacts(cart);
      if (facts.eligibleCount < 2) throw new Error('Shopify לא החזיר את זוג הכדים הצפוי.');
      nodes.heading.textContent = 'הסל עודכן';
      emit('bs_second_pitcher_added', { drawer_state: 'PAIR', second_pitcher_variant: selectedSecondVariant, cart_total: cart.total_price }, 'second-add:' + cart.token + ':' + selectedSecondVariant + ':' + cart.item_count);
      return renderDrawer();
    }).catch(function (error) {
      return getCart().then(function (cart) { latestCart = cart; renderRecoverableError(error, cart); }).catch(function () { renderRecoverableError(error); });
    }).finally(function () { mutationPending = false; });
  }

  function renderPair(body, cart, facts) {
    var nodes = prepareShell('PAIR', cart, facts);
    nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-context"><p class="bs-cart-eyebrow">זוג כדים</p><h3 class="bs-cart-state-title">שני הכדים שלכם בסל</h3>' +
      (facts.pairDiscountApplied ?
        '<p class="bs-cart-state-copy">הנחת <strong>' + escapeHtml(facts.pairDiscountTitles.join(' · ')) + '</strong> הוחלה על הפריטים למעלה.</p><div class="bs-cart-discount-summary"><span>חיסכון לזוג</span><span>' + money(facts.pairDiscountAmount, cart.currency) + '</span></div>' :
        '<div class="bs-cart-notice">הנחת ההטבה אינה מופיעה עדיין. הסכום המוצג למטה הוא הסכום הנוכחי; רעננו לפני התשלום כדי לבדוק שוב.</div>') +
      '</div>';
    emit('bs_cart_state_view', { drawer_state: 'PAIR', cart_total: cart.total_price, pair_discount: facts.pairDiscountAmount }, 'state:PAIR:' + cart.token + ':' + cart.item_count + ':' + cart.total_price);
  }

  function starterKitReconcilePlan(cart) {
    var facts = cartFacts(cart);
    var updates = {};
    if (facts.preset) {
      if (!PRESET_STARTER_KIT_ENABLED) return { action: 'error', facts: facts, updates: updates, message: 'צירוף ערכת ההתחלה לסט המוכן אינו פעיל.' };
      if (!facts.presetAtOfferTotal) {
        facts.starterKitCartLines.forEach(function (line) { updates[line.key] = 0; });
        return { action: 'error', facts: facts, updates: updates, message: 'Shopify לא אימת מחיר של 399 ₪ לכל סט מוכן.' };
      }
      if (facts.presetKitVerified) return { action: 'none', facts: facts, updates: updates };
      if (facts.starterKitCartLines.length === 1 && facts.presetKitCartLines.length === 1 &&
          kitLineIsNativeZero(facts.presetKitCartLines[0])) {
        updates[facts.presetKitCartLines[0].key] = facts.presetQuantity;
        return { action: 'update-preset', facts: facts, updates: updates, addQuantity: 0 };
      }
      facts.starterKitCartLines.forEach(function (line) { updates[line.key] = 0; });
      return {
        action: facts.starterKitCartLines.length ? 'replace-preset' : 'add-preset',
        facts: facts,
        updates: updates,
        addQuantity: facts.presetQuantity
      };
    }
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.starterKitVerified) return { action: 'none', facts: facts, updates: updates };
    if (!facts.starterKitCount) return { action: 'none', facts: facts, updates: updates };
    facts.starterKitCartLines.forEach(function (line) { updates[line.key] = 0; });
    return { action: 'remove', facts: facts, updates: updates };
  }

  function verifyPresetStarterKit(cart) {
    var facts = cartFacts(cart);
    if (!facts.presetKitVerified) throw new Error('Shopify לא אימת ערכת התחלה אמיתית במחיר 0 ₪ לכל סט מוכן.');
    return cart;
  }

  function removeInvalidStarterKits(cart, error) {
    var facts = cartFacts(cart);
    if (!facts.starterKitCount) throw error;
    var updates = {};
    facts.starterKitCartLines.forEach(function (line) { updates[line.key] = 0; });
    return updateCartLines(updates).then(getCart).then(function () { throw error; });
  }

  function performStarterKitReconciliation(cart) {
    var plan = starterKitReconcilePlan(cart);
    if (plan.action === 'none') return Promise.resolve(cart);
    if (plan.action === 'error') {
      var error = new Error(plan.message);
      if (!Object.keys(plan.updates).length) return Promise.reject(error);
      return updateCartLines(plan.updates).then(getCart).then(function () { throw error; });
    }
    if (plan.action === 'remove') {
      return updateCartLines(plan.updates).then(getCart).then(function (refreshed) {
        emit('bs_starter_kit_removed', {
          drawer_state: 'L1',
          reason: plan.facts.presetKitQuantity ? 'preset_removed' : (plan.facts.eligibleCount !== 2 ? 'eligibility_lost' : 'authority_failed'),
          cart_total: refreshed.total_price
        }, 'starter-kit-removed:' + refreshed.token + ':' + refreshed.item_count + ':' + refreshed.total_price);
        return refreshed;
      });
    }
    if (plan.action === 'update-preset') {
      return updateCartLines(plan.updates).then(getCart).then(verifyPresetStarterKit).then(function (verified) {
        emit('bs_preset_kit_reconciled', {
          drawer_state: 'P0',
          preset_quantity: cartFacts(verified).presetQuantity,
          kit_quantity: cartFacts(verified).presetKitQuantity,
          cart_total: verified.total_price
        }, 'preset-kit-update:' + verified.token + ':' + cartFacts(verified).presetQuantity + ':' + verified.total_price);
        return verified;
      }).catch(function (error) { return getCart().then(function (current) { return removeInvalidStarterKits(current, error); }); });
    }
    var removeExisting = Object.keys(plan.updates).length ? updateCartLines(plan.updates).then(getCart) : Promise.resolve(cart);
    return removeExisting.then(function () {
      return addCartItems([{
        id: STARTER_KIT_VARIANT_ID,
        quantity: plan.addQuantity,
        properties: starterKitProperties(PRESET_KIT_SOURCE)
      }]);
    }).then(getCart).then(verifyPresetStarterKit).then(function (verified) {
      var verifiedFacts = cartFacts(verified);
      emit('bs_preset_kit_reconciled', {
        drawer_state: 'P0',
        preset_quantity: verifiedFacts.presetQuantity,
        kit_quantity: verifiedFacts.presetKitQuantity,
        cart_total: verified.total_price
      }, 'preset-kit-add:' + verified.token + ':' + verifiedFacts.presetQuantity + ':' + verified.total_price);
      return verified;
    }).catch(function (error) { return getCart().then(function (current) { return removeInvalidStarterKits(current, error); }); });
  }

  function reconcileStarterKitAuthority(cart) {
    if (!PRESET_STARTER_KIT_ENABLED && !CUSTOM_PAIR_STARTER_KIT_ENABLED) return Promise.resolve(cart);
    if (starterKitReconcilePromise) return starterKitReconcilePromise;
    managedKitReconcilePending = true;
    starterKitReconcilePromise = performStarterKitReconciliation(cart).finally(function () {
      managedKitReconcilePending = false;
      starterKitReconcilePromise = null;
    });
    return starterKitReconcilePromise;
  }

  function renderStarterKitReady(body, cart, facts) {
    var nodes = prepareShell('E2', cart, facts);
    nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-context"><p class="bs-cart-eyebrow">זוג כדים ב־399 ₪</p>' +
      '<h3 class="bs-cart-state-title">הזוג שלכם הושלם ב־399 ₪</h3>' +
      '<div class="bs-cart-discount-summary"><span>חסכתם</span><span>139 ₪</span></div>' +
      '<h4 class="bs-section-title">ערכת התחלה בת 3 חלקים כלולה</h4>' +
      '<p class="bs-cart-state-copy">מגבת בריסטה · פאק סקרין 58.5 מ״מ · עט לאטה ארט</p></div>';
    nodes.checkout.setAttribute('data-bs-action', 'add-starter-kit');
    nodes.checkout.textContent = 'הוספת ערכת ההתחלה';
    emit('bs_starter_kit_prompt_view', { drawer_state: 'E2', cart_total: cart.total_price }, 'state:E2:' + cart.token + ':' + cart.total_price);
  }

  function addStarterKit() {
    if (!CUSTOM_PAIR_STARTER_KIT_ENABLED || mutationPending) return;
    var nodes = drawerNodes();
    mutationPending = true;
    nodes.checkout.disabled = true;
    nodes.checkout.textContent = 'מוסיפים את ערכת ההתחלה…';
    getCart().then(function (before) {
      var beforeFacts = cartFacts(before);
      if (!beforeFacts.pairAtOfferTotal || beforeFacts.starterKitCount) throw new Error('לא הצלחנו לאמת זוג כדים ב־399 ₪.');
      return addCartItems([{
        id: STARTER_KIT_VARIANT_ID,
        quantity: 1,
        properties: starterKitProperties(CUSTOM_PAIR_KIT_SOURCE)
      }]);
    }).then(getCart).then(function (after) {
      var afterFacts = cartFacts(after);
      if (!afterFacts.starterKitVerified) {
        return reconcileStarterKitAuthority(after).then(function () {
          throw new Error('Shopify לא אימת ערכת התחלה אחת ב־0 ₪ תוך שמירה על הנחת Two for 399 ועל סכום של 399 ₪. הערכה הוסרה.');
        });
      }
      emit('bs_starter_kit_added', { drawer_state: 'E3', variant_id: STARTER_KIT_VARIANT_ID, cart_total: after.total_price }, 'starter-kit:' + after.token);
      return renderDrawer();
    }).catch(function (error) {
      return getCart().then(reconcileStarterKitAuthority).then(function (cart) {
        latestCart = cart;
        renderRecoverableError(error, cart);
      }).catch(function () { renderRecoverableError(error); });
    }).finally(function () {
      mutationPending = false;
      setMutationBusy(false);
    });
  }

  function renderCompletePair(body, cart, facts) {
    var nodes = prepareShell('E3', cart, facts);
    nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-context"><p class="bs-cart-eyebrow">סט לאטה ארט מלא</p>' +
      '<h3 class="bs-cart-state-title">הסט המלא שלכם מוכן</h3>' +
      '<p class="bs-cart-state-copy">שני כדים + ערכת התחלה ב־399 ₪</p>' +
      '<p class="bs-cart-state-copy">מגבת בריסטה · פאק סקרין 58.5 מ״מ · עט לאטה ארט</p></div>';
    nodes.totalLabel.textContent = 'סה״כ לסט המלא';
    nodes.total.textContent = '399 ₪';
    nodes.checkout.textContent = 'לתשלום — 399 ₪';
    emit('bs_cart_state_view', { drawer_state: 'E3', cart_total: cart.total_price, starter_kit_variant: STARTER_KIT_VARIANT_ID }, 'state:E3:' + cart.token + ':' + cart.total_price);
  }

  function showMutationError(button, message) {
    var old = button.parentNode.querySelector('.bs-stage-error');
    if (old) old.remove();
    button.insertAdjacentHTML('beforebegin', '<div class="bs-stage-error">' + escapeHtml(message) + '</div>');
  }

  function removeHiddenLines(cart) {
    var updates = {};
    cart.items.forEach(function (line) {
      if (Number(line.variant_id) === HIDDEN_SET_VARIANT_ID) updates[line.key] = 0;
    });
    return Object.keys(updates).length ? updateCartLines(updates) : Promise.resolve(cart);
  }

  function convertSingleToHiddenSet(firstLine, secondVariantId, button) {
    if (mutationPending) return;
    mutationPending = true;
    button.disabled = true;
    button.textContent = 'BUILDING YOUR SET…';
    var firstItem = eligibleById(firstLine.variant_id);
    var secondItem = eligibleById(secondVariantId);
    var hiddenWasAdded = false;
    var hiddenKey = '';
    return refreshAvailability().then(function () {
      if (!firstItem || !secondItem) throw new Error('Those pitcher selections are not eligible for this set.');
      if (!firstItem.available || !secondItem.available) throw new Error('One of those pitchers is no longer available. Please choose another.');
      return getCart();
    }).then(function (before) {
      var beforeFacts = cartFacts(before);
      var currentFirst = before.items.find(function (line) { return line.key === firstLine.key && Number(line.variant_id) === Number(firstLine.variant_id); });
      if (!currentFirst || beforeFacts.eligibleCount !== 1 || beforeFacts.hiddenCount) throw new Error('Your cart changed. It has been reloaded before converting the set.');
      return addCartItems([{ id: HIDDEN_SET_VARIANT_ID, quantity: 1, properties: hiddenSetProperties(firstItem, secondItem, path) }]);
    }).then(function () {
      hiddenWasAdded = true;
      return getCart();
    }).then(function (afterAdd) {
      var addedFacts = cartFacts(afterAdd);
      if (addedFacts.hiddenCount !== 1 || !addedFacts.hiddenValid) throw new Error('The complete set could not be verified at $119.');
      hiddenKey = addedFacts.hiddenLine.key;
      var updates = {};
      updates[firstLine.key] = 0;
      return updateCartLines(updates);
    }).then(function () { return getCart(); }).then(function (finalCart) {
      var finalFacts = cartFacts(finalCart);
      if (!finalFacts.hiddenValid || finalFacts.hiddenCount !== 1 || finalFacts.eligibleCount !== 0 || finalCart.items.some(function (line) { return line.key === firstLine.key; })) {
        throw new Error('The final $119 cart state could not be verified.');
      }
      emit('bs_custom_set_conversion_success', {
        drawer_state: 'E3',
        first_variant_id: firstItem.variantId,
        second_variant_id: secondItem.variantId,
        first_sku: firstItem.sku,
        second_sku: secondItem.sku,
        preset_or_custom: 'custom_set'
      }, 'custom-set:' + finalCart.token + ':' + firstItem.variantId + ':' + secondItem.variantId);
      return renderDrawer();
    }).catch(function (error) {
      var cleanup = hiddenWasAdded ? getCart().then(function (cart) {
        var sourceStillPresent = cart.items.some(function (line) { return Number(line.variant_id) === firstItem.variantId && Number(line.product_id) !== HIDDEN_SET_PRODUCT_ID; });
        if (sourceStillPresent) return cart;
        return addCartItems([{ id: firstItem.variantId, quantity: 1 }]).then(getCart);
      }).then(removeHiddenLines).catch(function () { return null; }) : Promise.resolve();
      return cleanup.then(function () {
        emit('bs_custom_set_conversion_error', { drawer_state: 'ERR', second_variant_id: secondVariantId, error_code: 'conversion_failed' }, 'convert-error:' + Date.now());
        button.disabled = false;
        button.textContent = 'TRY AGAIN';
        showMutationError(button, error.message + ' Your original pitcher has been retained.');
      });
    }).finally(function () { mutationPending = false; });
  }

  function hiddenPropertiesHtml(line) {
    var properties = line.properties || {};
    return '<ul class="bs-stage-property-list">' +
      '<li><strong>First Pitcher</strong>' + escapeHtml(properties['First Pitcher']) + '</li>' +
      '<li><strong>Second Pitcher</strong>' + escapeHtml(properties['Second Pitcher']) + '</li>' +
      '<li><strong>ערכת התחלה כלולה</strong>מגבת בריסטה · פאק סקרין 58.5 מ״מ · עט לאטה ארט</li></ul>';
  }

  function renderHiddenSet(body, cart, facts) {
    var valid = facts.hiddenValid && !facts.hiddenConflict;
    var otherItems = cart.items.filter(function (line) { return !facts.hiddenLine || line.key !== facts.hiddenLine.key; });
    body.dataset.state = valid ? 'E3' : 'ERR';
    if (!valid) emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'hidden_set_conflict', cart_total: cart.total_price }, 'hidden-conflict:' + cart.token + ':' + cart.item_count);
    body.innerHTML = '<p class="bs-stage-eyebrow">COMPLETE $119 SET</p><h3 class="bs-stage-title">' + (valid ? 'Your Complete Latte Art Set Is Ready' : 'Your set needs attention') + '</h3>' +
      (facts.hiddenLine ? hiddenPropertiesHtml(facts.hiddenLine) : '') +
      '<div class="bs-stage-total"><span>Complete set</span><span>' + (facts.hiddenLine ? money(facts.hiddenLine.final_line_price) : money(0)) + '</span></div>' +
      (otherItems.length ? '<p class="bs-stage-copy"><strong>Other cart items</strong></p><ul class="bs-stage-items">' + otherItems.map(lineHtml).join('') + '</ul><div class="bs-stage-total"><span>Cart total</span><span>' + money(cart.total_price) + '</span></div>' : '') +
      (valid ? '<p class="bs-stage-copy">שני הכדים שנבחרו וערכת ההתחלה כלולים.</p>' : '<div class="bs-stage-error">התשלום מושהה כי הסל אינו מכיל סט מותאם מאומת אחד ב־399 ₪.</div>') +
      regionalHtml() + guaranteeHtml() +
      (valid ? '<button class="bs-stage-action" type="button" data-bs-checkout>CONTINUE TO CHECKOUT</button><button class="bs-stage-secondary" type="button" data-bs-restart-set>EDIT MY PITCHER CHOICES</button>' : '<button class="bs-stage-action" type="button" data-bs-retry>REFRESH CART</button>');
    if (valid) {
      bindCheckout(body, 'E3');
      if (otherItems.length) bindLineActions(body, cart);
      body.querySelector('[data-bs-restart-set]').addEventListener('click', function () { restartHiddenSet(facts.hiddenLine, this); });
    } else body.querySelector('[data-bs-retry]').addEventListener('click', renderDrawer);
  }

  function restartHiddenSet(hiddenLine, button) {
    if (mutationPending) return;
    mutationPending = true;
    button.disabled = true;
    button.textContent = 'RESTORING FIRST PITCHER…';
    var firstId = Number((hiddenLine.properties || {})._first_variant_id);
    var firstItem = eligibleById(firstId);
    var firstAdded = false;
    return refreshAvailability().then(function () {
      if (!firstItem || !firstItem.available) throw new Error('Your original first pitcher is not currently available. The completed set was left unchanged.');
      return addCartItems([{ id: firstId, quantity: 1 }]);
    }).then(function () { firstAdded = true; return getCart(); }).then(function (afterAdd) {
      if (!afterAdd.items.some(function (line) { return Number(line.variant_id) === firstId; })) throw new Error('Your first pitcher could not be restored.');
      var updates = {}; updates[hiddenLine.key] = 0;
      return updateCartLines(updates);
    }).then(function () { return getCart(); }).then(function (finalCart) {
      var finalFacts = cartFacts(finalCart);
      if (finalFacts.hiddenCount || finalFacts.eligibleCount !== 1) throw new Error('The edit state could not be verified.');
      emit('bs_pair_edit', { drawer_state: 'E1', first_variant_id: firstId }, 'pair-edit:' + finalCart.token + ':' + Date.now());
      return renderDrawer();
    }).catch(function (error) {
      var rollback = firstAdded ? getCart().then(function (cart) {
        var updates = {};
        cart.items.forEach(function (line) { if (Number(line.variant_id) === firstId && Number(line.product_id) !== HIDDEN_SET_PRODUCT_ID) updates[line.key] = 0; });
        return Object.keys(updates).length ? updateCartLines(updates) : cart;
      }).catch(function () { return null; }) : Promise.resolve();
      return rollback.then(function () { button.disabled = false; button.textContent = 'REMOVE SET AND START AGAIN'; showMutationError(button, error.message); });
    }).finally(function () { mutationPending = false; });
  }

  function renderLegacyPair(body, cart, facts) {
    var convertible = facts.eligibleCount === 2;
    body.dataset.state = convertible ? 'LEGACY' : 'ERR';
    body.innerHTML = '<p class="bs-stage-eyebrow">זוג כדים קיים</p><h3 class="bs-stage-title">' + (convertible ? 'השלימו את הסט והוסיפו את ערכת ההתחלה ללא תוספת תשלום.' : 'השאירו בסל שני כדים משתתפים בלבד.') + '</h3>' +
      '<ul class="bs-stage-items">' + cart.items.map(lineHtml).join('') + '</ul>' +
      (convertible ? '<p class="bs-stage-copy">Convert these exact two pitchers into one complete $119 set. Unrelated items will stay in your cart.</p><button class="bs-stage-action" type="button" data-bs-convert-legacy>CONVERT TO COMPLETE $119 SET</button>' : '<div class="bs-stage-error">Automatic conversion is paused because more than two eligible pitcher units are present.</div>') +
      regionalHtml() + guaranteeHtml();
    bindLineActions(body, cart);
    if (convertible) body.querySelector('[data-bs-convert-legacy]').addEventListener('click', function () { convertLegacyPair(facts.eligibleLines, this); });
  }

  function convertLegacyPair(lines, button) {
    if (mutationPending) return;
    mutationPending = true;
    button.disabled = true;
    button.textContent = 'CONVERTING…';
    var firstItem = eligibleById(lines[0].variant_id);
    var secondItem = eligibleById(lines[1].variant_id);
    var hiddenWasAdded = false;
    return refreshAvailability().then(function () {
      if (!firstItem || !secondItem || !firstItem.available || !secondItem.available) throw new Error('One of these pitchers is no longer available.');
      return addCartItems([{ id: HIDDEN_SET_VARIANT_ID, quantity: 1, properties: hiddenSetProperties(firstItem, secondItem, path) }]);
    }).then(function () { hiddenWasAdded = true; return getCart(); }).then(function (afterAdd) {
      var addedFacts = cartFacts(afterAdd);
      if (!addedFacts.hiddenValid || addedFacts.hiddenCount !== 1) throw new Error('The $119 complete set could not be verified.');
      var updates = {};
      lines.forEach(function (line) { updates[line.key] = 0; });
      return updateCartLines(updates);
    }).then(function () { return getCart(); }).then(function (finalCart) {
      var finalFacts = cartFacts(finalCart);
      if (!finalFacts.hiddenValid || finalFacts.hiddenConflict || finalFacts.eligibleCount) throw new Error('The converted cart could not be verified.');
      emit('bs_legacy_pair_conversion', { drawer_state: 'E3', first_variant_id: firstItem.variantId, second_variant_id: secondItem.variantId }, 'legacy:' + finalCart.token + ':' + Date.now());
      return renderDrawer();
    }).catch(function (error) {
      var cleanup = hiddenWasAdded ? getCart().then(function (cart) {
        var facts = cartFacts(cart);
        if (facts.eligibleCount >= 2) return cart;
        var required = {};
        required[firstItem.variantId] = (required[firstItem.variantId] || 0) + 1;
        required[secondItem.variantId] = (required[secondItem.variantId] || 0) + 1;
        facts.eligibleLines.forEach(function (line) { required[Number(line.variant_id)] = Math.max(0, (required[Number(line.variant_id)] || 0) - 1); });
        var restoreItems = Object.keys(required).filter(function (id) { return required[id] > 0; }).map(function (id) { return { id: Number(id), quantity: required[id] }; });
        return restoreItems.length ? addCartItems(restoreItems).then(getCart) : cart;
      }).then(removeHiddenLines).catch(function () { return null; }) : Promise.resolve();
      return cleanup.then(function () { button.disabled = false; button.textContent = 'TRY CONVERSION AGAIN'; showMutationError(button, error.message + ' Your original pitcher lines were retained.'); });
    }).finally(function () { mutationPending = false; });
  }

  function setMutationBusy(busy) {
    var nodes = drawerNodes();
    if (!nodes) return;
    if (busy) nodes.root.querySelectorAll('[data-bs-quantity],[data-bs-remove],[data-bs-add-second],[data-bs-undo]').forEach(function (control) {
      control.disabled = true;
    });
    nodes.checkout.disabled = Boolean(busy);
    if (!busy && lastRemovedItem) {
      var undo = nodes.toast.querySelector('[data-bs-undo]');
      if (undo) undo.disabled = false;
    }
  }

  function lineChangeRequest(key, quantity) {
    function request(payload) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (response.ok) return response.json();
        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || 'לא הצלחנו לעדכן את הפריט בסל.');
        });
      });
    }
    return request({ id: key, quantity: quantity }).catch(function (firstError) {
      return getCart().then(function (cart) {
        var index = cart.items.findIndex(function (line) { return String(line.key) === String(key); });
        if (index < 0) throw firstError;
        return request({ line: index + 1, quantity: quantity });
      });
    });
  }

  function changeCartLine(key, quantity) {
    if (!key || mutationPending || quantity < 0) return;
    mutationPending = true;
    setMutationBusy(true);
    var before = latestCart;
    var beforeFacts = before ? cartFacts(before) : null;
    lineChangeRequest(key, quantity).then(getCart).then(function (cart) {
      latestCart = cart;
      var afterFacts = cartFacts(cart);
      if (beforeFacts && beforeFacts.eligibleCount >= 2 && afterFacts.eligibleCount < 2) {
        emit('bs_eligibility_lost', { drawer_state: 'L1', cart_total: cart.total_price }, 'lost:' + cart.token + ':' + cart.item_count + ':' + cart.total_price);
      }
      var nodes = drawerNodes();
      if (nodes) nodes.heading.textContent = 'הסל עודכן';
      return renderDrawer();
    }).catch(function (error) {
      emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'quantity_failed' }, 'quantity:' + Date.now());
      return getCart().then(function (cart) {
        latestCart = cart;
        renderRecoverableError(error, cart);
      }).catch(function () { renderRecoverableError(error); });
    }).finally(function () {
      mutationPending = false;
      setMutationBusy(false);
    });
  }

  function showUndoToast() {
    var nodes = drawerNodes();
    if (!nodes || !lastRemovedItem) return;
    nodes.toast.hidden = false;
    var undo = nodes.toast.querySelector('[data-bs-undo]');
    if (undo) undo.disabled = false;
    var label = nodes.toast.querySelector('span');
    if (label) label.textContent = (lastRemovedItem.product_title || lastRemovedItem.title || 'הפריט') + ' הוסר';
    if (undoTimer) clearTimeout(undoTimer);
    undoTimer = setTimeout(function () {
      nodes.toast.hidden = true;
      lastRemovedItem = null;
      undoTimer = null;
    }, 12000);
  }

  function removeCartLine(key) {
    if (!key || mutationPending) return;
    var sourceCart = latestCart;
    var sourceLine = sourceCart && sourceCart.items.find(function (line) { return String(line.key) === String(key); });
    if (!sourceLine) {
      renderRecoverableError(new Error('שורת הסל השתנתה. רעננו את הסל ונסו שוב.'), sourceCart);
      return;
    }
    lastRemovedItem = JSON.parse(JSON.stringify(sourceLine));
    mutationPending = true;
    setMutationBusy(true);
    var beforeFacts = cartFacts(sourceCart);
    lineChangeRequest(key, 0).then(getCart).then(function (cart) {
      latestCart = cart;
      var afterFacts = cartFacts(cart);
      if (beforeFacts.eligibleCount >= 2 && afterFacts.eligibleCount < 2) {
        emit('bs_eligibility_lost', { drawer_state: 'L1', cart_total: cart.total_price }, 'lost:' + cart.token + ':' + cart.item_count + ':' + cart.total_price);
      }
      var nodes = drawerNodes();
      if (nodes) nodes.heading.textContent = 'הפריט הוסר';
      return renderDrawer().then(showUndoToast);
    }).catch(function (error) {
      lastRemovedItem = null;
      emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'remove_failed' }, 'remove:' + Date.now());
      return getCart().then(function (cart) {
        latestCart = cart;
        renderRecoverableError(error, cart);
      }).catch(function () { renderRecoverableError(error); });
    }).finally(function () {
      mutationPending = false;
      setMutationBusy(false);
    });
  }

  function undoRemove() {
    if (!lastRemovedItem || mutationPending) return;
    var item = lastRemovedItem;
    var restore = {
      id: Number(item.variant_id),
      quantity: Number(item.quantity || 1)
    };
    if (item.properties && Object.keys(item.properties).length) restore.properties = item.properties;
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) restore.selling_plan = item.selling_plan_allocation.selling_plan.id;
    mutationPending = true;
    setMutationBusy(true);
    addCartItems([restore]).then(getCart).then(function (cart) {
      latestCart = cart;
      lastRemovedItem = null;
      if (undoTimer) clearTimeout(undoTimer);
      var nodes = drawerNodes();
      if (nodes) {
        nodes.toast.hidden = true;
        nodes.heading.textContent = 'הפריט הוחזר';
      }
      emit('bs_cart_remove_undo', { drawer_state: 'UNDO', variant_id: restore.id, quantity: restore.quantity }, 'undo:' + cart.token + ':' + restore.id + ':' + cart.item_count);
      return renderDrawer();
    }).catch(function (error) {
      return getCart().then(function (cart) {
        latestCart = cart;
        renderRecoverableError(error, cart);
      }).catch(function () { renderRecoverableError(error); });
    }).finally(function () {
      mutationPending = false;
      setMutationBusy(false);
    });
  }

  function verifyCheckoutAuthority(cart) {
    var facts = cartFacts(cart);
    if (!cart.item_count) throw new Error('הסל שלכם ריק.');
    if (facts.preset && !facts.presetKitVerified) throw new Error('לא הצלחנו לאמת את כמות ערכות ההתחלה לסט המוכן. רעננו את הסל.');
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.mixedOffer) throw new Error('הסירו את הסט המוכן או את הסט בהתאמה אישית לפני התשלום.');
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.hiddenCount && (!facts.hiddenValid || facts.hiddenConflict)) throw new Error('הסט בהתאמה אישית אינו מאומת. בדקו את הסל לפני התשלום.');
    if (!facts.preset && CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.starterKitCount && !facts.starterKitVerified) throw new Error('ערכת ההתחלה לא אומתה במחיר 0 ₪ ולכן יש להסירה לפני התשלום.');
    return facts;
  }

  function checkoutCart() {
    if (mutationPending) return;
    var nodes = drawerNodes();
    mutationPending = true;
    nodes.checkout.disabled = true;
    nodes.checkout.textContent = 'בודקים את הסל…';
    getCart().then(reconcileStarterKitAuthority).then(function (cart) {
      latestCart = cart;
      var facts = verifyCheckoutAuthority(cart);
      emit('bs_checkout_click', {
        drawer_state: lastRenderedState,
        cart_total: cart.total_price,
        cart_item_count: cart.item_count,
        preset_or_custom: facts.preset ? 'preset' : (facts.hiddenCount ? 'custom_set' : (facts.eligibleCount === 2 ? 'standalone_pair' : 'ordinary'))
      }, 'checkout:' + cart.token + ':' + cart.total_price + ':' + cart.item_count);
      sessionStorage.removeItem('bs_white_drawer_open');
      location.assign('/checkout');
    }).catch(function (error) {
      return getCart().then(function (cart) {
        latestCart = cart;
        renderRecoverableError(error, cart);
      }).catch(function () { renderRecoverableError(error); });
    }).finally(function () {
      mutationPending = false;
      setMutationBusy(false);
    });
  }

  // Compatibility stubs for feature-flagged custom-pair code. Delegation owns all live actions.
  function bindLineActions() {}
  function bindCheckout() {}

  function primaryForm() {
    var forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    return forms.find(function (form) {
      return visibleSubmit(form) !== null;
    }) || null;
  }

  function visibleSubmit(form) {
    return Array.from(form.querySelectorAll('button[type="submit"],input[type="submit"]')).find(function (control) {
      return control.offsetParent !== null;
    }) || null;
  }

  function setFormVariant(form, variantId) {
    form.dataset.bsSelectedVariant = String(variantId);
    form.querySelectorAll('[name="id"]').forEach(function (input) {
      input.value = String(variantId);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function injectProductSelector() {
    if (!CUSTOM_PAIR_PRODUCT_PAGE_SELECTOR_ENABLED) return;
    var kind = path === ROUTES.evo ? 'evo' : (path === ROUTES.vortex ? 'vortex' : '');
    if (!kind || document.querySelector('.bs-stage-first-selector')) return;
    if (!availabilityCheckedAt && !window.__bsStageAvailabilityLoading) {
      window.__bsStageAvailabilityLoading = true;
      refreshAvailability().catch(function () {}).then(function () {
        availabilityCheckedAt = availabilityCheckedAt || Date.now();
        window.__bsStageAvailabilityLoading = false;
        injectProductSelector();
      });
      return;
    }
    var form = primaryForm();
    if (!form) return;
    var submit = visibleSubmit(form);
    if (!submit) return;
    var choices = kind === 'evo' ? ELIGIBLE.filter(function (item) { return item.productId === 8438816637229; }) : ELIGIBLE.filter(function (item) { return item.product === 'Vortex'; });
    var initial = null;
    var wrap = document.createElement('div');
    wrap.className = 'bs-stage-first-selector';
    wrap.innerHTML = '<fieldset><legend>' + (kind === 'evo' ? 'Choose your EVO finish' : 'Choose your Vortex style') + '</legend><div class="bs-stage-first-options">' + choices.map(function (item) {
      return '<button class="bs-stage-first-choice" type="button" data-bs-first="' + item.variantId + '" aria-pressed="' + String(initial && initial.variantId === item.variantId) + '" ' + (item.available ? '' : 'disabled') + '>' +
        '<img src="' + item.image + '" alt=""><strong>' + escapeHtml(item.option) + '</strong><span class="bs-selected">SELECTED</span></button>';
    }).join('') + '</div></fieldset>';
    var offer = document.createElement('div');
    offer.className = 'bs-stage-offer';
    offer.innerHTML = '<p class="bs-stage-eyebrow">הטבה לזוג כדים</p><h3>בחרו שני כדים משתתפים ב־399 ₪.</h3><p>כד אחד עולה 269 ₪. הוסיפו כד ראשון ובחרו את הכד הנוסף מתוך הסל. לאחר השלמת הזוג תוכלו להוסיף את ערכת ההתחלה ללא תוספת תשלום.</p>';
    submit.parentNode.insertBefore(wrap, submit);
    submit.parentNode.insertBefore(offer, submit);
    submit.insertAdjacentHTML('afterend', '<span class="bs-stage-helper">בשלב הבא: בחרו את הכד השני והשלימו את ההטבה.</span>');
    submit.textContent = kind === 'evo' ? 'ADD EVO 2.0 + CHOOSE SECOND PITCHER' : 'ADD VORTEX + CHOOSE SECOND PITCHER';
    submit.setAttribute('aria-label', submit.textContent);
    submit.disabled = true;
    wrap.querySelectorAll('[data-bs-first]').forEach(function (button) {
      button.addEventListener('click', function () {
        var selected = Number(button.dataset.bsFirst);
        wrap.querySelectorAll('[data-bs-first]').forEach(function (candidate) { candidate.setAttribute('aria-pressed', String(candidate === button)); });
        setFormVariant(form, selected);
        submit.disabled = false;
        emit('bs_first_variant_selected', { product_id: choices.find(function (item) { return item.variantId === selected; }).productId, variant_id: selected }, 'first:' + selected);
      });
    });
    function handleFirstAdd(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!form.dataset.bsSelectedVariant) {
        alert(kind === 'evo' ? 'Please choose your EVO finish.' : 'Please choose With Handle or No Handle.');
        return;
      }
      if (form.dataset.bsSubmitting === 'true') return;
      form.dataset.bsSubmitting = 'true';
      managedAddPending = true;
      submit.disabled = true;
      var previous = submit.textContent;
      submit.textContent = 'ADDING…';
      var selectedId = Number(form.dataset.bsSelectedVariant);
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: selectedId, quantity: 1 }] }) })
        .then(function (response) { if (!response.ok) throw new Error('The selected pitcher could not be added.'); return response.json(); })
        .then(function () {
          sessionStorage.setItem('bs_stage_post_add', '1');
          emit('bs_first_pitcher_added', { variant_id: selectedId }, 'first-add:' + selectedId + ':' + Date.now());
          openDrawer(submit);
        })
        .catch(function (error) {
          emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'first_add_failed', variant_id: selectedId }, 'first-add-error:' + Date.now());
          alert(error.message);
        })
        .finally(function () { managedAddPending = false; form.dataset.bsSubmitting = 'false'; submit.disabled = false; submit.textContent = previous; });
    }
    submit.addEventListener('click', handleFirstAdd, true);
    form.addEventListener('submit', handleFirstAdd, true);
    emit('bs_offer_view', { product_id: choices[0].productId, variant_id: null }, 'offer:' + kind);
  }

  function bindBundleAdd() {
    if (path !== ROUTES.bundle) return;
    var form = primaryForm();
    if (!form || form.dataset.bsPresetBound === 'true') return;
    var submit = visibleSubmit(form);
    if (!submit) return;
    form.dataset.bsPresetBound = 'true';
    function handlePresetAdd(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.bsSubmitting === 'true') return;
      var idInput = form.querySelector('[name="id"]');
      var selectedId = idInput ? Number(idInput.value) : 0;
      if (PRESET_VARIANTS.indexOf(selectedId) === -1) {
        alert('בחרו גימור EVO לפני הוספת הסט.');
        return;
      }
      form.dataset.bsSubmitting = 'true';
      managedAddPending = true;
      submit.disabled = true;
      var previous = submit.textContent;
      submit.textContent = 'מוסיפים…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: selectedId, quantity: 1 }] }) })
        .then(function (response) { if (!response.ok) throw new Error('לא הצלחנו להוסיף את הסט המלא.'); return response.json(); })
        .then(getCart)
        .then(reconcileStarterKitAuthority)
        .then(function (verifiedCart) {
          if (!cartFacts(verifiedCart).presetKitVerified) throw new Error('לא הצלחנו לאמת ערכת התחלה אמיתית ב־0 ₪.');
          sessionStorage.setItem('bs_stage_post_add', '1');
          emit('bs_first_pitcher_added', { product_id: PRESET_PRODUCT_ID, variant_id: selectedId, preset_or_custom: 'preset', preset_quantity: cartFacts(verifiedCart).presetQuantity, kit_quantity: cartFacts(verifiedCart).presetKitQuantity }, 'preset-add:' + selectedId + ':' + Date.now());
          openDrawer(submit);
        })
        .catch(function (error) {
          emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'preset_add_failed', variant_id: selectedId }, 'preset-add-error:' + Date.now());
          alert(error.message);
        })
        .finally(function () { managedAddPending = false; form.dataset.bsSubmitting = 'false'; submit.disabled = false; submit.textContent = previous; });
    }
    submit.addEventListener('click', handlePresetAdd, true);
    form.addEventListener('submit', handlePresetAdd, true);
  }

  function bindIsraeliPairOfferAdd() {
    if (path !== ROUTES.evo && path !== ROUTES.vortex) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.bsPairOfferBound === 'true') return;
      var submit = Array.from(form.querySelectorAll('button[type="submit"],input[type="submit"]')).find(function (control) {
        return /שני כדים|2 כדים/.test(control.textContent || control.value || '') && /399/.test(control.textContent || control.value || '');
      });
      // Current premium EVO/Vortex templates use concise Hebrew CTA copy that no
      // longer repeats "399" inside the button. On these two product routes the
      // primary visible Shopify form is still the authoritative add form.
      if (!submit && form === primaryForm()) submit = visibleSubmit(form);
      if (!submit) return;
      form.dataset.bsPairOfferBound = 'true';

      function handlePairOfferAdd(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.dataset.bsSubmitting === 'true') return;
        var idInput = form.querySelector('[name="id"]');
        var selectedId = idInput ? Number(idInput.value) : 0;
        if (QUALIFYING_FIRST_IDS.indexOf(selectedId) === -1) {
          alert('בחרו כד EVO 2.0 או Vortex משתתף לפני ההוספה.');
          return;
        }
        form.dataset.bsSubmitting = 'true';
        managedAddPending = true;
        submit.disabled = true;
        var previous = submit.textContent;
        submit.textContent = 'מוסיפים את הכד הראשון…';
        addCartItems([{ id: selectedId, quantity: 1 }])
          .then(getCart)
          .then(function (cart) {
            var facts = cartFacts(cart);
            if (!facts.eligibleLines.some(function (line) { return Number(line.variant_id) === selectedId; })) {
              throw new Error('Shopify לא אימת את הכד הראשון בסל.');
            }
            sessionStorage.setItem('bs_stage_post_add', '1');
            emit('bs_first_pitcher_added', { variant_id: selectedId, preset_or_custom: 'custom-pair' }, 'first-add:' + selectedId + ':' + Date.now());
            return openDrawer(submit);
          })
          .catch(function (error) {
            emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'first_add_failed', variant_id: selectedId }, 'first-add-error:' + Date.now());
            alert(error.message);
          })
          .finally(function () {
            managedAddPending = false;
            form.dataset.bsSubmitting = 'false';
            submit.disabled = false;
            submit.textContent = previous;
          });
      }

      submit.addEventListener('click', handlePairOfferAdd, true);
      form.addEventListener('submit', handlePairOfferAdd, true);
    });
  }

  function injectContract() {
    // Product-page commercial copy is already owned by the current premium templates.
    // Keeping this as a no-op prevents the retired black engine from injecting a second contract.
    return;
  }

  function styleBundlePromise() {
    // The Israeli product templates own their commercial copy.
    return;
  }

  function correctScopedCopy() {
    // Avoid rewriting unrelated Hebrew product-page content.
    return;
  }

  function normalizeProductGuarantee() {
    // The drawer carries the approved guarantee; product templates remain untouched.
    return;
  }

  function enhanceSelectorFallback() {
    if (!CUSTOM_PAIR_PRODUCT_PAGE_SELECTOR_ENABLED) return;
    if (path !== ROUTES.selector || document.getElementById('bs-stage-selector-copy')) return;
    var block = document.createElement('section');
    block.id = 'bs-stage-selector-copy';
    block.className = 'bs-stage-contract';
    var main = document.querySelector('main') || document.body;
    main.insertBefore(block, main.firstChild);
    document.body.classList.add('bs-stage-commerce-active');
    document.body.classList.add('bs-stage-selector-active');
    Promise.all([getCart(), refreshAvailability()]).then(function (results) {
      var cart = results[0];
      var facts = cartFacts(cart);
      if (facts.hiddenCount) {
        block.innerHTML = '<p class="bs-stage-eyebrow">סט מלא ב־399 ₪</p><h1 class="bs-stage-title">הסט שלכם מוכן.</h1><p class="bs-stage-copy">בדקו את שני הכדים ואת ערכת ההתחלה הכלולה.</p><button class="bs-stage-action" type="button" data-bs-open-cart>בדיקת הסט המלא</button>';
        block.querySelector('[data-bs-open-cart]').addEventListener('click', function () { openDrawer(this); });
        return;
      }
      if (facts.eligibleCount !== 1) {
        block.innerHTML = '<h1 class="bs-stage-title">Choose Your Second Pitcher</h1><p class="bs-stage-copy">Add your first eligible pitcher before completing the $119 set.</p><button class="bs-stage-action" type="button" data-bs-open-cart>REVIEW MY CART</button>';
        block.querySelector('[data-bs-open-cart]').addEventListener('click', function () { openDrawer(this); });
        return;
      }
      block.innerHTML = '<p class="bs-stage-eyebrow">השלימו זוג כדים ב־399 ₪</p><h1 class="bs-stage-title">בחרו כד נוסף</h1><p class="bs-stage-copy">כד אחד עולה 269 ₪. לאחר הוספת הכד הנוסף, המחיר הכולל לשני הכדים יתעדכן ל־399 ₪.</p><div class="bs-stage-options">' + SECOND_OPTIONS.map(function (item) {
        return '<button class="bs-stage-option" type="button" data-bs-selector-second="' + item.variantId + '" ' + (item.available ? '' : 'disabled') + '><img src="' + item.image + '" alt=""><strong>' + escapeHtml(item.product) + '</strong><small>' + escapeHtml(item.option) + (item.available ? ' · במלאי' : ' · אזל מהמלאי') + '</small></button>';
      }).join('') + '</div><button class="bs-stage-action" type="button" data-bs-selector-complete disabled>SELECT A SECOND PITCHER</button>';
      var chosen = null;
      block.querySelectorAll('[data-bs-selector-second]').forEach(function (choice) {
        choice.addEventListener('click', function () {
          chosen = Number(choice.dataset.bsSelectorSecond);
          block.querySelectorAll('[data-bs-selector-second]').forEach(function (candidate) { candidate.setAttribute('aria-pressed', String(candidate === choice)); });
          var item = eligibleById(chosen);
          var action = block.querySelector('[data-bs-selector-complete]');
          action.disabled = false;
          action.textContent = 'COMPLETE MY SET WITH ' + item.product.toUpperCase() + ' — ' + item.option.toUpperCase();
          emit('bs_second_pitcher_selected', { drawer_state: 'SELECTOR', second_variant_id: chosen }, 'selector:' + chosen);
        });
      });
      block.querySelector('[data-bs-selector-complete]').addEventListener('click', function () {
        if (!chosen) return;
        convertSingleToHiddenSet(facts.eligibleLines[0], chosen, this).then(function () { openDrawer(block.querySelector('[data-bs-selector-complete]')); });
      });
    }).catch(function (error) {
      block.innerHTML = '<div class="bs-stage-error">' + escapeHtml(error.message) + '</div><button class="bs-stage-action" type="button" data-bs-open-cart>REVIEW MY CART</button>';
      block.querySelector('[data-bs-open-cart]').addEventListener('click', function () { openDrawer(this); });
    });
  }

  function bindFullCartCheckoutGuard() {
    if (path !== ROUTES.cart || document.documentElement.getAttribute('data-bs-cart-checkout-guard') === 'true') return;
    document.documentElement.setAttribute('data-bs-cart-checkout-guard', 'true');
    window.addEventListener('click', function (event) {
      var trigger = event.target.closest('button[name="checkout"],#checkout');
      if (!trigger || mutationPending) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      mutationPending = true;
      trigger.disabled = true;
      var previous = trigger.textContent;
      trigger.textContent = 'בודקים את הסל…';
      getCart().then(reconcileStarterKitAuthority).then(function (cart) {
        latestCart = cart;
        verifyCheckoutAuthority(cart);
        sessionStorage.removeItem('bs_white_drawer_open');
        location.assign('/checkout');
      }).catch(function (error) {
        return openDrawer(trigger, 'הסל דורש בדיקה').then(function () {
          if (latestCart) renderRecoverableError(error, latestCart);
        }).catch(function () { alert(error.message); });
      }).finally(function () {
        mutationPending = false;
        trigger.disabled = false;
        trigger.textContent = previous;
      });
    }, true);
  }

  function enhanceCartPage() {
    if (path !== ROUTES.cart || document.getElementById('bs-stage-cart-contract')) return;
    var beforeFacts = null;
    getCart().then(function (beforeCart) {
      beforeFacts = cartFacts(beforeCart);
      return reconcileStarterKitAuthority(beforeCart);
    }).then(function (cart) {
      var afterFacts = cartFacts(cart);
      if (beforeFacts && beforeFacts.starterKitCount !== afterFacts.starterKitCount) {
        location.reload();
        return null;
      }
      return cart;
    }).then(function (cart) {
      if (!cart) return;
      var facts = cartFacts(cart);
      var nativeOffer = Array.from(document.querySelectorAll('strong')).find(function (element) {
        return /2 כדים.*399|399.*2 כדים/i.test(element.textContent || '');
      });
      if (nativeOffer) {
        if (facts.preset) nativeOffer.textContent = 'סט מלא: 399 ₪ ליחידה ✓';
        else if (facts.eligibleCount === 2 && facts.pairDiscountApplied) nativeOffer.textContent = 'הנחת Shopify לזוג כדים הוחלה ✓';
        else if (facts.eligibleCount === 2) nativeOffer.textContent = 'שני כדים נפרדים · בדקו את הסכום למטה';
        else if (facts.eligibleCount === 1) nativeOffer.textContent = 'הוסיפו כד משתתף נוסף כדי להפעיל את ההטבה';
        else if (nativeOffer.parentElement) nativeOffer.parentElement.hidden = true;
      }
      var block = document.createElement('section');
      block.id = 'bs-stage-cart-contract';
      block.className = 'bs-cart-page-contract';
      if (facts.preset) {
        block.innerHTML = '<strong>' + (facts.mixedPreset ? 'מחיר הסט: 399 ₪ ליחידה' : (facts.presetQuantity > 1 ? facts.presetQuantity + ' סטים מלאים · 399 ₪ ליחידה' : 'סט לאטה ארט מלא · 399 ₪')) + '</strong>' +
          '<p>399 ₪ מחיר סופי, כולל מע״מ ומשלוח. לאטה ארט טוב יותר בתוך 21 יום, או שתקבלו את כספכם בחזרה. בקשת החזר עד היום ה־45 ומשלוח החזרה חינם.</p>' +
          '<p>הסכום בפועל בסל: <strong>' + money(cart.total_price, cart.currency) + '</strong></p>';
      } else if (facts.eligibleCount === 2) {
        block.innerHTML = '<strong>שני כדים נפרדים</strong>' +
          '<p>' + (facts.pairDiscountApplied ? 'הנחת Shopify הוחלה: ' + escapeHtml(facts.pairDiscountTitles.join(' · ')) + ' (חיסכון של ' + money(facts.pairDiscountAmount, cart.currency) + ').' : 'אין כרגע הקצאת Two for 399 בסל Shopify.') + '</p>' +
          '<p>הסכום בפועל בסל: <strong>' + money(cart.total_price, cart.currency) + '</strong>.</p>';
      } else if (facts.eligibleCount === 1 && QUALIFYING_FIRST_IDS.indexOf(Number(facts.eligibleLines[0].variant_id)) !== -1) {
        block.innerHTML = '<strong>כד משתתף אחד בסל</strong><p>פתחו את חלונית הסל כדי לבחור כד נוסף מתוך האפשרויות הזמינות. הסכום וההנחה נקבעים לפי הסל שמחזיר Shopify.</p>';
      } else return;
      var checkoutButton = document.querySelector('button[name="checkout"],#checkout');
      var checkoutGroup = checkoutButton && checkoutButton.closest('.checkout_button');
      var cartSummary = checkoutButton && checkoutButton.closest('.subtotal');
      var main = document.querySelector('main') || document.body;
      if (cartSummary) cartSummary.insertBefore(block, checkoutGroup || checkoutButton);
      else main.appendChild(block);
    }).catch(function () {});
    document.body.classList.add('bs-stage-commerce-active');
  }

  function cartTriggerSelector() {
    return '#cart-icon-bubble,a[href="/cart"],a[href$="/cart"],[data-cart-trigger],[data-cart-drawer-trigger],[data-action="open-mini-cart"],.mini_cart,.js-drawer-open-cart,button[aria-controls="cart-drawer"]';
  }

  function interceptHeaderCart() {
    window.addEventListener('click', function (event) {
      var trigger = event.target.closest(cartTriggerSelector());
      if (!trigger || path === ROUTES.cart) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openDrawer(trigger);
    }, true);
  }

  function bindHeaderCartLinks() {
    if (path === ROUTES.cart) return;
    document.querySelectorAll(cartTriggerSelector()).forEach(function (trigger) {
      if (trigger.getAttribute('data-bs-stage-cart-bound') === 'true') return;
      trigger.setAttribute('data-bs-stage-cart-bound', 'true');
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openDrawer(trigger);
      }, true);
    });
  }

  function interceptCartRequests() {
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      return nativeFetch.apply(this, args).then(function (response) {
        if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url) && response.ok && !managedKitReconcilePending) {
          sessionStorage.setItem('bs_stage_post_add', '1');
          setTimeout(function () { if (!managedAddPending && !mutationPending && !document.querySelector('[data-bs-selected-variant]') && !document.querySelector('#bs-cart-drawer-root[aria-hidden="false"]')) openDrawer(document.activeElement); }, 50);
        }
        return response;
      });
    };

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__bsCartAddRequest = /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url || ''));
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__bsCartAddRequest) this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        sessionStorage.setItem('bs_stage_post_add', '1');
        setTimeout(function () {
          if (!managedAddPending && !mutationPending && !document.querySelector('#bs-cart-drawer-root[aria-hidden="false"]')) openDrawer(document.activeElement);
        }, 50);
      }, { once: true });
      return nativeSend.apply(this, arguments);
    };
  }

  function boot() {
    injectStyles();
    initBundleMobileWhatsapp();
    suppressWheelio(document);
    suppressLegacyDrawer(document);
    bindLegacyCartClassGuards();
    ensureDrawer();
    interceptHeaderCart();
    bindHeaderCartLinks();
    interceptCartRequests();
    if (isPurchasePath) correctScopedCopy();
    if (isPurchasePath) normalizeProductGuarantee();
    if (isPurchasePath) enhanceSelectorFallback();
    bindFullCartCheckoutGuard();
    enhanceCartPage();
    if (isPurchasePath) styleBundlePromise();
    if (isPurchasePath) bindBundleAdd();
    if (isPurchasePath) bindIsraeliPairOfferAdd();
    if (isPurchasePath) injectProductSelector();
    if (sessionStorage.getItem('bs_white_drawer_open') === '1') openDrawer(document.activeElement);
    if (isPurchasePath) [300, 1200].forEach(function (delay) {
      setTimeout(function () { correctScopedCopy(); styleBundlePromise(); }, delay);
    });
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes && record.addedNodes.forEach(function (node) { if (node.nodeType === 1) { suppressWheelio(node); suppressLegacyDrawer(node); } });
      });
      bindLegacyCartClassGuards();
      if (isPurchasePath) injectProductSelector();
      bindHeaderCartLinks();
      if (isPurchasePath) styleBundlePromise();
      if (isPurchasePath) bindBundleAdd();
      if (isPurchasePath) bindIsraeliPairOfferAdd();
      if (isPurchasePath) normalizeProductGuarantee();
      initBundleMobileWhatsapp();
    }).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pageshow', function () {
      if (sessionStorage.getItem('bs_white_drawer_open') === '1') openDrawer(document.activeElement, 'הסל שלכם');
    });
    window.addEventListener('popstate', function () {
      if (sessionStorage.getItem('bs_white_drawer_open') === '1') renderDrawer();
    });
    window.BaristaSwagCartDrawer = {
      open: function () { return openDrawer(document.activeElement, 'הסל שלכם'); },
      close: closeDrawer,
      refresh: renderDrawer,
      version: VERSION
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
